(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const getState = () => document.querySelector('.cart-page');

    const setLoading = (on) => {
      const page = getState();
      if (page) page.classList.toggle('is-loading', on);
    };

    // Re-render the cart page + header popover by re-fetching the current page.
    // This avoids any dependency on a section id (which can differ per store) and
    // guarantees the UI reflects the server cart after every mutation.
    const refresh = async () => {
      const res = await fetch(location.pathname, { headers: { Accept: 'text/html' }, cache: 'no-store' });
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const nextCart = doc.querySelector('.cart-page');
      const currentCart = getState();
      if (nextCart && currentCart) currentCart.replaceWith(nextCart);
      const nextInner = doc.querySelector('.cart-popover__inner');
      const currentInner = document.querySelector('[data-cart-popover] .cart-popover__inner');
      if (nextInner && currentInner) currentInner.replaceWith(nextInner);
      const nextCount = doc.querySelector('.header__cart-count');
      if (nextCount) {
        document.querySelectorAll('.header__cart-count').forEach((node) => {
          node.textContent = nextCount.textContent;
          node.hidden = nextCount.hasAttribute('hidden');
        });
      }
      document.dispatchEvent(new CustomEvent('cart:update'));
    };

    const mutate = async (url, payload) => {
      setLoading(true);
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) return false;
        await refresh();
        return true;
      } finally {
        setLoading(false);
      }
    };

    // Change a line by its 1-based line number (reliable across the AJAX Cart API).
    const changeLine = (line, quantity) => mutate('/cart/change.js', { line: line, quantity: quantity });

    // Quantity stepper + direct input.
    document.addEventListener('click', (event) => {
      const down = event.target.closest('[data-step-down]');
      const up = event.target.closest('[data-step-up]');
      if (!down && !up) return;
      const btn = down || up;
      const line = btn.dataset.line;
      const input = document.querySelector('.cart-page__qty-input[data-line="' + line + '"]');
      if (!input) return;
      let qty = parseInt(input.value, 10) || 0;
      qty = up ? qty + 1 : Math.max(0, qty - 1);
      input.value = qty;
      changeLine(parseInt(line, 10), qty);
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('.cart-page__qty-input');
      if (!input) return;
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(parseInt(input.dataset.line, 10), qty);
    });

    // Remove line.
    document.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-remove-line]');
      if (!remove) return;
      event.preventDefault();
      changeLine(parseInt(remove.dataset.line, 10), 0);
    });

    // Swap a line's variant: /cart/change.js cannot change a line's variant id.
    // Remove the old line FIRST (its line index is still valid before any add),
    // then add the new variant. Doing it in this order avoids the line index
    // shifting once a new line is appended. Restore the old variant if the add fails.
    const postJSON = (url, body) =>
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });

    document.addEventListener('click', async (event) => {
      const card = event.target.closest('[data-select-variant]');
      if (!card) return;
      const newVariant = parseInt(card.dataset.variantId, 10);
      const oldVariant = parseInt(card.dataset.oldVariantId, 10);
      const quantity = parseInt(card.dataset.quantity, 10) || 1;
      const oldLine = parseInt(card.dataset.line, 10);
      let properties = {};
      try {
        properties = JSON.parse(card.dataset.properties || '{}');
      } catch (e) {
        properties = {};
      }
      // Empty line-item properties serialize to [] in Liquid; the AJAX API needs a hash.
      if (!properties || Array.isArray(properties) || typeof properties !== 'object') properties = {};
      const addBody = (id) => {
        const body = { id: id, quantity: quantity };
        if (Object.keys(properties).length) body.properties = properties;
        return body;
      };

      setLoading(true);
      try {
        const removed = await postJSON('/cart/change.js', { line: oldLine, quantity: 0 });
        if (!removed.ok) {
          console.error('[cart] remove old line failed', removed.status, await removed.json().catch(() => ({})));
          return;
        }
        const added = await postJSON('/cart/add.js', addBody(newVariant));
        if (!added.ok) {
          const err = await added.json().catch(() => ({}));
          console.error('[cart] add variant failed', added.status, err);
          // Restore the original variant so the line isn't lost.
          await postJSON('/cart/add.js', addBody(oldVariant));
          window.alert(err.description || err.message || 'This option is unavailable.');
        }
      } finally {
        await refresh();
        setLoading(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  function initializeCollectionList(section) {
    const track = section.querySelector('.collection-list__items')
    const items = Array.from(section.querySelectorAll('.collection-list__item'))
    const previous = section.querySelector('[data-slider-previous]')
    const next = section.querySelector('[data-slider-next]')
    const dots = Array.from(section.querySelectorAll('[data-slide-index]'))
    let points = []
    let pointerId = null
    let pointerStartX = 0
    let pointerStartY = 0
    let pointerStartScroll = 0
    let isDragging = false
    let directionLocked = false
    let suppressClick = false

    if (!track || items.length === 0) return

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true')
        else dot.removeAttribute('aria-current')
      })
      if (previous) previous.disabled = index === 0
      if (next) next.disabled = index >= points.length - 1
    }

    const currentIndex = () => {
      let closestIndex = 0
      let closestDistance = Number.POSITIVE_INFINITY
      points.forEach((point, index) => {
        const distance = Math.abs(track.scrollLeft - point)
        if (distance < closestDistance) {
          closestDistance = distance
          closestIndex = index
        }
      })
      return closestIndex
    }

    const goTo = (index) => {
      const point = points[Math.max(0, Math.min(index, points.length - 1))]
      track.scrollTo({ left: point, behavior: 'smooth' })
    }

    const update = () => {
      const trackStyle = getComputedStyle(track)
      const isSlider = trackStyle.overflowX === 'auto' || trackStyle.overflowX === 'scroll'
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth)
      const trackLeft = track.getBoundingClientRect().left
      points = items
        .map((item) => item.getBoundingClientRect().left - trackLeft + track.scrollLeft)
        .map((point) => Math.min(Math.max(0, point), maxScroll))
        .filter((point, index, values) => index === 0 || Math.abs(point - values[index - 1]) > 1)

      const hasOverflow = isSlider && maxScroll > 1 && points.length > 1
      section.classList.toggle('collection-list--has-overflow', hasOverflow)
      dots.forEach((dot, index) => {
        dot.hidden = !hasOverflow || index >= points.length
      })
      setActive(hasOverflow ? currentIndex() : 0)
    }

    previous?.addEventListener('click', () => goTo(currentIndex() - 1))
    next?.addEventListener('click', () => goTo(currentIndex() + 1))
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)))
    track.addEventListener('dragstart', (event) => event.preventDefault())
    track.addEventListener('pointerdown', (event) => {
      if (!section.classList.contains('collection-list--has-overflow')) return
      if (!event.isPrimary || event.button !== 0) return
      pointerId = event.pointerId
      pointerStartX = event.clientX
      pointerStartY = event.clientY
      pointerStartScroll = track.scrollLeft
      isDragging = false
      directionLocked = false
      suppressClick = false
    })
    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return
      const distanceX = event.clientX - pointerStartX
      const distanceY = event.clientY - pointerStartY

      if (!directionLocked) {
        if (Math.abs(distanceX) < 6 && Math.abs(distanceY) < 6) return
        directionLocked = true
        if (Math.abs(distanceY) >= Math.abs(distanceX)) return
        isDragging = true
        track.setPointerCapture(pointerId)
        track.classList.add('is-dragging')
      }

      if (!isDragging) return
      event.preventDefault()
      track.scrollLeft = pointerStartScroll - distanceX
    })

    const finishDrag = (event) => {
      if (event.pointerId !== pointerId) return
      if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId)
      pointerId = null
      if (!isDragging) return
      isDragging = false
      suppressClick = true
      track.classList.remove('is-dragging')
      goTo(currentIndex())
      setTimeout(() => {
        suppressClick = false
      }, 0)
    }

    track.addEventListener('pointerup', finishDrag)
    track.addEventListener('pointercancel', finishDrag)
    track.addEventListener('click', (event) => {
      if (!suppressClick) return
      event.preventDefault()
      event.stopPropagation()
    }, true)
    track.addEventListener('scroll', () => requestAnimationFrame(() => setActive(currentIndex())), { passive: true })
    const resizeObserver = new ResizeObserver(update)
    resizeObserver.observe(track)
    update()
  }

  document.querySelectorAll('[data-collection-list]').forEach(initializeCollectionList)
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-collection-list]')
    if (section) initializeCollectionList(section)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  function initCollection(root) {
    if (!root || root.dataset.clInit === 'true') return
    root.dataset.clInit = 'true'

    var form = root.querySelector('[data-facet-form]')
    if (form) {
      form.addEventListener('change', function (event) {
        var target = event.target
        if (target && (target.matches('input') || target.matches('select'))) {
          form.submit()
        }
      })
    }

    var results = root.querySelector('[data-results]')
    var viewButtons = root.querySelectorAll('[data-view-set]')
    var storageKey = 'collection-view'

    function applyView(view) {
      if (!results) return
      results.dataset.view = view
      viewButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.dataset.viewSet === view ? 'true' : 'false')
      })
    }

    if (results) {
      var stored = null
      try {
        stored = localStorage.getItem(storageKey)
      } catch (error) {
        stored = null
      }
      if (stored === 'grid' || stored === 'list') applyView(stored)

      viewButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var view = button.dataset.viewSet
          applyView(view)
          try {
            localStorage.setItem(storageKey, view)
          } catch (error) {}
        })
      })
    }

    function closeFilters() {
      root.classList.remove('filters-open')
    }

    root.querySelectorAll('[data-filter-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.classList.add('filters-open')
      })
    })
    root.querySelectorAll('[data-filter-close]').forEach(function (element) {
      element.addEventListener('click', closeFilters)
    })
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeFilters()
    })
  }

  document.querySelectorAll('[data-collection]').forEach(initCollection)
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-collection]')
    if (section) initCollection(section)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["generating"]) return;
  try {
    
  /* ==========================================================================
   * Story Generating — drives the real /generate SSE stream.
   *
   * Reads the personalisation choices from the URL (?product, ?style, ?name,
   * plus optional ?story/?age/?gender/?lang), POSTs them to the backend, and
   * parses the Server-Sent Events stream (progress* → preview → done) exactly
   * like the prototype's api/client.js. `progress` events move the bar and swap
   * the status line; the `preview` payload is stored for the Preview page, then
   * we redirect there.
   *
   * The 20–30 seconds this takes are the only moment in the flow where the
   * shopper has committed and has nothing to do, so the wait carries an offer:
   * the print editions (the product's variants, in the same cards the cart
   * shows) and what other buyers said. It offers — it never sells. Nothing here
   * touches the cart; the chosen edition is only carried forward to Preview.
   * ======================================================================== */

  /* The bar must never claim more than the engine has reported, and must never
     go backwards. So the reported figure and the displayed figure are two
     different things: `target` only ever rises and stays below completion until
     the book has actually arrived; `shown` eases towards it and so can never
     overtake it. A silent interval therefore still moves, without lying. */
  var WB_GEN_CEILING = 99;
  var WB_GEN_EASE_MS = 60;
  var WB_GEN_EASE_FRACTION = 0.08;  /* of the remaining distance, per tick */
  var WB_GEN_EASE_FLOOR = 0.25;     /* …but always at least this, so it never stalls */
  var WB_GEN_DONE_HOLD_MS = 450;    /* let the shopper see it reach 100 before moving on */

  function initGenerating(root) {
    if (!root || root.__genInit) return;
    root.__genInit = true;

    var proxyBase = '/apps';
    var previewPage = root.dataset.previewPage || '/pages/preview';

    var loadingEl = root.querySelector('[data-loading]');
    var errorEl = root.querySelector('[data-error]');
    var errorMsgEl = root.querySelector('[data-error-msg]');
    var sectionsEl = root.querySelector('[data-sections]');
    var editionsEl = root.querySelector('[data-editions]');
    var fmtsEl = root.querySelector('[data-fmts]');
    var fillEl = root.querySelector('[data-fill]');
    var barEl = root.querySelector('[data-bar]');
    var pctEl = root.querySelector('[data-pct]');
    var msgEl = root.querySelector('[data-msg]');
    var retryBtn = root.querySelector('[data-retry]');
    var backBtn = root.querySelector('[data-back]');

    var params = new URLSearchParams(location.search);
    var handle = params.get('product') || params.get('handle') || params.get('product_handle') || '';
    var storyId = params.get('story') || root.dataset.storyId || handle;
    // Only the style the shopper actually picked on the product page. No local
    // default: an id the story does not offer is a 422 VALIDATION_FAILED, and an
    // omitted art_style means "the story's own default" to the partner API.
    var artStyle = params.get('style') || '';
    var childName = params.get('name') || 'Friend';
    var age = parseInt(params.get('age'), 10); if (!age || age < 1 || age > 12) age = 5;
    var gender = params.get('gender'); if (['girl', 'boy', 'other'].indexOf(gender) < 0) gender = 'other';
    var photoId = params.get('photoId') || '';
    // Guest id is stored in localStorage ('asn:guest') on the product page; read
    // it from there instead of the URL (falls back to the URL for older links).
    // Logged-in customers are identified by the proxy's signed logged_in_customer_id,
    // so we don't send a guest id for them (keeps end_user_id consistent with upload).
    var customerId = root.dataset.customerId || '';
    var guestId = '';
    if (!customerId) {
      try { guestId = localStorage.getItem('asn:guest') || ''; } catch (e) { guestId = ''; }
      if (!guestId) guestId = params.get('guest_id') || '';
    }
    var teaserPages = parseInt(params.get('teaser'), 10); if (isNaN(teaserPages) || teaserPages < 0 || teaserPages > 6) teaserPages = 2;
    var language = params.get('lang') || 'EN';
    // The backend takes teaser_pages/story_id from the merchant binding, keyed by
    // product — forward both the product gid and handle so it can look it up.
    var productGid = params.get('product_gid') || '';
    var productHandle = params.get('product') || '';

    var formatKey = 'dreamstory:format:' + handle;

    /* Friendly fallback lines, cycled until the server sends its own (mirrors
       the prototype's WB_GEN_MESSAGES). */
    var FALLBACK = [
      'Painting the eyes just right…',
      'Picking out the perfect outfit…',
      'Adding an adorable little smile…',
      'Putting in the finishing touches…',
      'Almost there, hang tight!'
    ];
    var msgTimer = null, gotServerMsg = false, mi = 0;

    // Cap stored preview payloads to `maxKeep` (excluding the current handle we're
    // about to write). Removes older 'dreamstory:preview:*' keys first.
    function evictOldPreviews(maxKeep) {
      try {
        var prefix = 'dreamstory:preview:';
        var keys = [];
        for (var i = 0; i < sessionStorage.length; i++) {
          var k = sessionStorage.key(i);
          if (k && k.indexOf(prefix) === 0 && k !== prefix + handle) keys.push(k);
        }
        // Keep room for the new key: trim down to (maxKeep - 1) existing others.
        var keep = Math.max(0, (maxKeep || 4) - 1);
        for (var j = 0; j < keys.length - keep; j++) sessionStorage.removeItem(keys[j]);
      } catch (e) { /* private mode / unavailable */ }
    }

    function setMsg(text) {
      if (!msgEl) return;
      msgEl.textContent = text;
      // re-trigger the fade-in (mirrors the prototype's key={message}).
      msgEl.style.animation = 'none';
      void msgEl.offsetWidth;
      msgEl.style.animation = '';
    }

    /* ---- progress: reported target vs eased display ---------------------- */
    var target = 0, shown = 0, easeTimer = null, holdTimer = null;

    function paint() {
      var whole = Math.round(shown);
      if (fillEl) fillEl.style.width = shown + '%';
      if (pctEl) pctEl.textContent = whole;
      if (barEl) barEl.setAttribute('aria-valuenow', whole);
    }
    function raiseTarget(p) {
      var reported = Math.min(WB_GEN_CEILING, Math.round((p || 0) * 100));
      if (reported > target) target = reported;
    }
    function startEase() {
      if (easeTimer) return;
      easeTimer = setInterval(function () {
        var gap = target - shown;
        if (gap <= 0.05) { if (target > shown) shown = target; return; }
        shown += Math.max(gap * WB_GEN_EASE_FRACTION, Math.min(gap, WB_GEN_EASE_FLOOR));
        paint();
      }, WB_GEN_EASE_MS);
    }
    function stopEase() { if (easeTimer) { clearInterval(easeTimer); easeTimer = null; } }
    function completeProgress() {
      // Only now may the display claim completion.
      stopEase();
      target = 100; shown = 100;
      paint();
      if (fillEl) fillEl.classList.add('done');
    }

    function startMsgCycle() {
      setMsg(FALLBACK[0]);
      msgTimer = setInterval(function () {
        if (gotServerMsg) return;
        mi = (mi + 1) % FALLBACK.length;
        setMsg(FALLBACK[mi]);
      }, 1600);
    }
    function stopMsgCycle() { if (msgTimer) { clearInterval(msgTimer); msgTimer = null; } }

    function showError(message) {
      stopMsgCycle();
      stopEase();
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      if (loadingEl) loadingEl.hidden = true;
      if (errorEl) errorEl.hidden = false;
      // Failure withdraws the offer: there is nothing to sell until there is a book.
      if (sectionsEl) sectionsEl.hidden = true;
      if (errorMsgEl) errorMsgEl.textContent = message || 'Generation failed';
    }

    /* ---- the editions on offer during the wait --------------------------- */
    // The cards come from the product's `edition-cards` alternate template, so
    // they carry the same metafields (badge, description) the cart cards do —
    // the Ajax API would drop them. Nothing here touches the cart: the choice is
    // remembered and handed to Preview.
    var selectedVariantId = '';
    try { selectedVariantId = sessionStorage.getItem(formatKey) || ''; } catch (e) { selectedVariantId = ''; }

    // `remember` is false for the selection the page opens with: only a choice
    // the shopper actually made should survive into the next visit.
    function pickFormat(card, remember) {
      if (!card || card.dataset.available === 'false') return;
      var cards = fmtsEl.querySelectorAll('[data-fmt]');
      for (var i = 0; i < cards.length; i++) {
        var on = cards[i] === card;
        cards[i].classList.toggle('on', on);
        cards[i].setAttribute('aria-checked', on ? 'true' : 'false');
        var cta = cards[i].querySelector('[data-fmt-cta]');
        if (cta) {
          cta.classList.toggle('on', on);
          var label = on ? cta.dataset.labelOn : cta.dataset.labelOff;
          if (label) cta.textContent = label;
        }
      }
      selectedVariantId = card.dataset.variantId || '';
      if (remember !== false) {
        try { sessionStorage.setItem(formatKey, selectedVariantId); } catch (e) { /* private mode */ }
      }
    }

    // The skeleton is not a fallback — it is a placeholder. Either real cards
    // replace it, or the offer was never available and the section goes away.
    function dropEditions() {
      if (editionsEl) editionsEl.hidden = true;
    }

    function wireEditions() {
      var cards = fmtsEl.querySelectorAll('[data-fmt]');
      if (!cards.length) { dropEditions(); return; }
      var fallbackBadge = root.dataset.badgeFallback || '';
      var showBadges = root.hasAttribute('data-show-badges');
      var wanted = null;

      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        // The template can't read the section's badge fallback, so apply it here.
        if (showBadges) {
          if (fallbackBadge) {
            var media = card.querySelector('.wb-fmt-media');
            if (media && !media.querySelector('.wb-fmt-ribbon')) {
              var chip = document.createElement('span');
              chip.className = 'wb-fmt-ribbon';
              chip.textContent = fallbackBadge;
              media.insertBefore(chip, media.firstChild);
            }
          }
        } else {
          var ribbon = card.querySelector('.wb-fmt-ribbon');
          if (ribbon) ribbon.remove();
        }
        if (selectedVariantId && card.dataset.variantId === selectedVariantId) wanted = card;
        (function (c) {
          c.addEventListener('click', function () { pickFormat(c); });
          c.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); pickFormat(c); }
          });
        })(card);
      }

      // A remembered edition wins, as long as it is still on offer. Otherwise
      // the page opens on the second edition on offer rather than the first one
      // the template marked, falling back to the first when only one is left.
      // Count over the available cards, not raw positions: pickFormat refuses a
      // sold-out card, so cards[1] could leave nothing selected at all.
      if (wanted) {
        pickFormat(wanted, false);
      } else {
        var offered = [];
        for (var o = 0; o < cards.length; o++) {
          if (cards[o].dataset.available !== 'false') offered.push(cards[o]);
        }
        var initial = offered[1] || offered[0];
        if (initial) {
          pickFormat(initial, false);
        } else {
          var current = fmtsEl.querySelector('.wb-fmt.on');
          if (current) selectedVariantId = current.dataset.variantId || '';
        }
      }
      fmtsEl.classList.remove('is-loading');
      fmtsEl.removeAttribute('aria-busy');
    }

    function loadEditions() {
      if (!fmtsEl) return;
      if (!handle) { dropEditions(); return; }
      // The product URL must carry the storefront's locale prefix, or Shopify
      // renders the cards in the default language while the page is in another:
      // variant titles, the Select/Selected labels and `money` would all disagree
      // with everything around them. routes.root_url is '/' on the primary locale
      // and '/vi' (no trailing slash) on a secondary one.
      var rootUrl = root.dataset.rootUrl || '/';
      if (rootUrl.charAt(rootUrl.length - 1) === '/') rootUrl = rootUrl.slice(0, -1);
      fetch(rootUrl + '/products/' + encodeURIComponent(handle) + '?view=edition-cards', {
        headers: { Accept: 'text/html' }
      })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r); })
        .then(function (html) {
          // Take the cards, never the page they arrived in. A 200 is not proof
          // that this is our fragment: a password-protected store answers the
          // redirect to /password with a full page, whose <style> tags would
          // apply document-wide the moment they were parsed into the document.
          // Importing only [data-fmt] nodes leaves everything else behind.
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var found = doc.querySelectorAll('[data-fmt]');
          if (!found.length) { dropEditions(); return; }
          fmtsEl.innerHTML = '';
          for (var i = 0; i < found.length; i++) {
            fmtsEl.appendChild(document.importNode(found[i], true));
          }
          wireEditions();
        })
        // The wait must never fail over the offer: no cards, no section.
        .catch(function () { dropEditions(); });
    }

    /* Parse an SSE body, dispatching each frame to handlers[event](data).
       Resolves on `done`/stream end; rejects on an `error` event. (1:1 with
       the prototype's readSSE.) */
    function readSSE(res, handlers) {
      var reader = res.body.getReader();
      var decoder = new TextDecoder();
      var buf = '';
      function pump() {
        return reader.read().then(function (r) {
          if (r.done) return;
          buf += decoder.decode(r.value, { stream: true });
          var frames = buf.split('\n\n');
          buf = frames.pop() || '';
          for (var f = 0; f < frames.length; f++) {
            var frame = frames[f];
            if (!frame.trim()) continue;
            var event = 'message', data = '';
            var lines = frame.split('\n');
            for (var l = 0; l < lines.length; l++) {
              var line = lines[l];
              if (line.indexOf('event:') === 0) event = line.slice(6).trim();
              else if (line.indexOf('data:') === 0) data += line.slice(5).trim();
            }
            var parsed = {};
            if (data) { try { parsed = JSON.parse(data); } catch (e) { /* ignore */ } }
            if (event === 'error') {
              var err = new Error(parsed.message || 'Generation failed');
              err.code = parsed.code;
              throw err;
            }
            if (event === 'done') return;   // resolve
            if (handlers[event]) handlers[event](parsed);
          }
          return pump();
        });
      }
      return pump();
    }

    function run() {
      if (errorEl) errorEl.hidden = true;
      if (loadingEl) loadingEl.hidden = false;
      if (sectionsEl) sectionsEl.hidden = false;
      gotServerMsg = false;
      target = 0; shown = 0;
      if (fillEl) fillEl.classList.remove('done');
      paint();
      raiseTarget(0.06);
      startEase();
      stopMsgCycle();
      startMsgCycle();

      var previewPayload = null;
      var body = {
        storyId: storyId,
        photoId: photoId,
        teaserPages: teaserPages,
        productGid: productGid,
        productHandle: productHandle,
        language: language,
        guest_id: guestId,
        child: { name: String(childName).slice(0, 20), age: age, gender: gender }
      };
      // Omitted, never empty — the backend reads "no art_style" as the story default.
      if (artStyle) body.artStyle = artStyle;

      fetch(proxyBase + '/upsell?queryType=ai-stories-next-generate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'text/event-stream' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (b) {
              var e = (b && b.error) || {};
              throw new Error(e.message || ('Request failed (' + res.status + ')'));
            });
          }
          return readSSE(res, {
            progress: function (d) {
              if (d && typeof d.progress === 'number') raiseTarget(d.progress);
              if (d && d.message) { gotServerMsg = true; setMsg(d.message); }
            },
            preview: function (d) { previewPayload = d; }
          });
        })
        .then(function () {
          stopMsgCycle();
          completeProgress();
          setMsg('Your book is ready!');
          // Hand the generated payload to the Preview page (same-tab handoff,
          // the multi-page equivalent of the prototype's in-memory state).
          if (previewPayload && handle) {
            // Keep at most a few recent preview payloads so sessionStorage can't
            // grow without bound when a shopper previews many products in one
            // session. Deep links still work via the session re-fetch on Preview.
            evictOldPreviews(4);
            try { sessionStorage.setItem('dreamstory:preview:' + handle, JSON.stringify(previewPayload)); } catch (e) { /* private mode / quota */ }
          }
          var url = previewPage || '/pages/preview';
          var sep = url.indexOf('?') >= 0 ? '&' : '?';
          // Only product + session are needed on Preview (childName comes from the
          // stored/re-fetched payload, not the URL) — plus the edition chosen
          // during the wait, so the buy bar opens on it.
          var q = 'product=' + encodeURIComponent(handle);
          if (previewPayload && previewPayload.session_id) q += '&session=' + encodeURIComponent(previewPayload.session_id);
          if (selectedVariantId) q += '&variant=' + encodeURIComponent(selectedVariantId);
          holdTimer = setTimeout(function () { location.assign(url + sep + q); }, WB_GEN_DONE_HOLD_MS);
        })
        .catch(function (e) { showError(e && e.message ? e.message : 'Generation failed'); });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function (e) {
        if (history.length > 1) { e.preventDefault(); history.back(); }
        // else: fall through to the href (all-products collection)
      });
    }
    if (retryBtn) retryBtn.addEventListener('click', run);

    // The offer loads independently of the stream — it must still be there when
    // the stream is slow, and must not delay it.
    loadEditions();

    // No story / no uploaded photo → show the error state (no blind API call).
    if (!storyId) {
      showError('No story selected. Please go back and pick a story.');
      if (retryBtn) retryBtn.hidden = true;
      return;
    }
    if (!photoId) {
      showError('No photo uploaded. Please go back and add a photo.');
      if (retryBtn) retryBtn.hidden = true;
      return;
    }
    run();
  }

  function initAllGenerating(scope) {
    (scope || document).querySelectorAll('[data-generating]').forEach(initGenerating);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllGenerating(); });
  } else {
    initAllGenerating();
  }
  document.addEventListener('shopify:section:load', function (e) { initAllGenerating(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    // Drawer (mobile) still uses native selects — auto-submit on change.
    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-header-country], [data-header-language]')) event.target.form.requestSubmit();
    });

    // Desktop localization is a custom <details> disclosure. Close it when clicking
    // outside or pressing Escape, and only allow one open at a time.
    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-loc-disclosure][open]').forEach((d) => {
        if (!d.contains(event.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        document.querySelectorAll('[data-loc-disclosure][open]').forEach((d) => d.removeAttribute('open'));
      }
    });
    document.querySelectorAll('[data-loc-disclosure]').forEach((d) => {
      d.addEventListener('toggle', () => {
        if (!d.open) return;
        document.querySelectorAll('[data-loc-disclosure][open]').forEach((o) => { if (o !== d) o.removeAttribute('open'); });
      });
    });

    // Close mobile drawer when clicking outside
    document.addEventListener('click', (event) => {
      const drawer = document.querySelector('.header__drawer[open]');
      if (drawer && !drawer.contains(event.target)) {
        drawer.removeAttribute('open');
      }
    });

    const root = document.querySelector('[data-cart-root]');
    if (root) {
      const toggle = root.querySelector('.header__cart-toggle');
      const popover = root.querySelector('[data-cart-popover]');

      const isOpen = () => popover.classList.contains('is-open');
      const open = () => {
        popover.classList.add('is-open');
        root.classList.add('is-cart-open');
        // Flag the whole document so sections outside the header's stacking
        // context (e.g. the story preview's fixed buy bar) can step aside while
        // the mobile cart drawer is open.
        document.documentElement.classList.add('cart-drawer-open');
        popover.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        popover.classList.remove('is-open');
        root.classList.remove('is-cart-open');
        document.documentElement.classList.remove('cart-drawer-open');
        popover.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
      };

      // Refresh the popover markup AND the cart badge from a freshly rendered
      // header section. The /cart/add.js response is the added line item (no
      // item_count), so the reliable count is the one Liquid rendered here.
      const applyHeader = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('.cart-popover__inner');
        const current = popover.querySelector('.cart-popover__inner');
        if (next && current) current.replaceWith(next);
        const nextCount = doc.querySelector('.header__cart-count');
        if (nextCount) {
          document.querySelectorAll('.header__cart-count').forEach((node) => {
            node.textContent = nextCount.textContent;
            node.hidden = nextCount.hasAttribute('hidden');
          });
        }
        document.dispatchEvent(new CustomEvent('cart:update'));
      };

      toggle.addEventListener('click', (event) => {
        event.stopPropagation();
        isOpen() ? close() : open();
      });
      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) close();
        else if (isOpen() && !root.contains(event.target)) close();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && isOpen()) close();
      });

      // Intercept add-to-cart to refresh and reveal the popover without a page reload.
      document.addEventListener('submit', async (event) => {
        const form = event.target.closest('form[action$="/cart/add"]');
        if (!form) return;
        event.preventDefault();
        const body = new FormData(form);
        body.append('sections', 'header');
        body.append('sections_url', location.pathname);
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
        const cart = await response.json();
        if (response.ok) {
          if (cart.sections && cart.sections['header']) applyHeader(cart.sections['header']);
          open();
        }
      });
    }

    // Search drawer & Predictive Search logic
    const headerEl = document.querySelector('.header');
    const searchOpenBtn = document.querySelector('[data-search-open]');
    const searchDrawer = document.querySelector('[data-search-drawer]');
    const searchCloseBtn = document.querySelector('[data-search-close]');
    const searchInput = searchDrawer ? searchDrawer.querySelector('.header__search-input') : null;
    const searchForm = searchDrawer ? searchDrawer.querySelector('.header__search-form') : null;
    const predictiveContainer = searchDrawer ? searchDrawer.querySelector('[data-predictive-search]') : null;
    const predictiveResults = predictiveContainer ? predictiveContainer.querySelector('[data-predictive-search-results]') : null;
    let searchDebounceTimer = null;

    if (headerEl && searchOpenBtn && searchDrawer) {
      const closePredictive = () => {
        if (predictiveContainer) {
          predictiveContainer.classList.remove('is-active');
          predictiveContainer.setAttribute('aria-hidden', 'true');
        }
        if (predictiveResults) {
          predictiveResults.innerHTML = '';
        }
      };

      const openSearch = () => {
        headerEl.classList.add('is-search-open');
        searchDrawer.setAttribute('aria-hidden', 'false');
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 80);
        }
      };

      const closeSearch = () => {
        closePredictive();
        headerEl.classList.remove('is-search-open');
        searchDrawer.setAttribute('aria-hidden', 'true');
      };

      const fetchPredictiveResults = async (query) => {
        const trimmed = query.trim();
        if (!trimmed) {
          closePredictive();
          return;
        }

        // Show loading spinner immediately while fetching
        if (predictiveResults && predictiveContainer) {
          predictiveResults.innerHTML = `
            <div class="predictive-search__container">
              <div class="predictive-search__loading">
                <div class="predictive-search__spinner" role="status" aria-label="Loading"></div>
              </div>
            </div>
          `;
          predictiveContainer.classList.add('is-active');
          predictiveContainer.setAttribute('aria-hidden', 'false');
        }

        const tSuggested = predictiveContainer.dataset.tSuggested || 'Suggested products';
        const tNoProductsRaw = predictiveContainer.dataset.tNoProducts || 'No products found for "[terms]"';
        const tSeeAllRaw = predictiveContainer.dataset.tSeeAll || 'See all results for "[terms]"';

        const tNoProducts = tNoProductsRaw.replace('[terms]', trimmed);
        const tSeeAll = tSeeAllRaw.replace('[terms]', trimmed);

        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(trimmed)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`);
          if (!res.ok) return;
          const data = await res.json();
          const products = data?.resources?.results?.products || [];

          let html = '<div class="predictive-search__container">';

          if (products.length > 0) {
            html += `<p class="predictive-search__heading">${tSuggested}</p>`;
            html += '<ul class="predictive-search__list" role="listbox">';
            products.forEach((prod) => {
              const imgUrl = prod.featured_image?.url || prod.image || '';
              const priceText = prod.price ? (typeof prod.price === 'number' ? prod.price + '₫' : prod.price) : '';
              
              html += `
                <li>
                  <a href="${prod.url}" class="predictive-search__item">
                    ${imgUrl ? `<img src="${imgUrl}" alt="${prod.title}" class="predictive-search__image" width="48" height="48">` : ''}
                    <div class="predictive-search__item-content">
                      <span class="predictive-search__item-title">${prod.title}</span>
                      ${priceText ? `<span class="predictive-search__item-price">${priceText}</span>` : ''}
                    </div>
                  </a>
                </li>
              `;
            });
            html += '</ul>';
          } else {
            html += `<div class="predictive-search__empty">${tNoProducts}</div>`;
          }

          // Footer: See all search results
          html += `
            <div class="predictive-search__footer">
              <button type="button" class="predictive-search__footer-btn" data-see-all>
                <span>${tSeeAll}</span>
                <span aria-hidden="true">→</span>
              </button>
            </div>
          `;

          html += '</div>';

          predictiveResults.innerHTML = html;
          
          const seeAllBtn = predictiveResults.querySelector('[data-see-all]');
          if (seeAllBtn && searchForm) {
            seeAllBtn.addEventListener('click', () => {
              searchForm.submit();
            });
          }

          predictiveContainer.classList.add('is-active');
          predictiveContainer.setAttribute('aria-hidden', 'false');
        } catch (err) {
          console.error('Predictive search error:', err);
        }
      };

      if (searchInput && predictiveContainer && predictiveResults) {
        searchInput.addEventListener('input', (e) => {
          clearTimeout(searchDebounceTimer);
          searchDebounceTimer = setTimeout(() => {
            fetchPredictiveResults(e.target.value);
          }, 200);
        });
      }

      searchOpenBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        openSearch();
      });

      if (searchCloseBtn) {
        searchCloseBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          closeSearch();
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && headerEl.classList.contains('is-search-open')) {
          closeSearch();
        }
      });

      document.addEventListener('click', (e) => {
        if (
          headerEl.classList.contains('is-search-open') &&
          !searchDrawer.contains(e.target) &&
          !searchOpenBtn.contains(e.target)
        ) {
          closeSearch();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  function initializeHeroCarousel(section) {
    const track = section.querySelector('.hero-carousel__track')
    const frame = section.querySelector('.hero-carousel__frame')
    const allItems = track ? Array.from(track.children) : []
    const maxSlides = Math.max(1, parseInt(section.dataset.maxSlides || '8', 10))
    allItems.forEach((item, position) => {
      item.hidden = position >= maxSlides
    })
    const items = allItems.slice(0, maxSlides)
    const previous = section.querySelector('[data-slider-previous]')
    const next = section.querySelector('[data-slider-next]')
    const dotsContainer = section.querySelector('[data-slider-dots]')
    const dots = Array.from(section.querySelectorAll('[data-slide-index]'))
    let points = []
    let pointerId = null
    let pointerStartX = 0
    let pointerStartY = 0
    let pointerStartScroll = 0
    let isDragging = false
    let directionLocked = false
    let suppressClick = false

    if (!track || items.length === 0) return

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const autoplayEnabled = section.dataset.autoplay === 'true'
    const autoplayInterval = Math.max(2, parseInt(section.dataset.autoplayInterval || '5', 10)) * 1000
    let autoplayTimer = null

    const engine = section.dataset.engine === 'transform' ? 'transform' : 'scroll'
    const isFade = section.classList.contains('hero-carousel--fade')
    const isStage = section.classList.contains('hero-carousel--stage')
    const loop = section.dataset.loop === 'true'
    const swipeEnabled = section.dataset.swipe !== 'false'
    const swipeThreshold = Math.max(10, parseInt(section.dataset.swipeThreshold || '40', 10))
    const slideCount = () => (engine === 'transform' ? items.length : points.length)
    let activeIndex = 0
    let dragOffset = 0

    const slideOf = (item) => {
      if (!item) return null
      if (item.classList.contains('hero-slide')) return item
      return item.querySelector('.hero-slide') || item
    }

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true')
        else dot.removeAttribute('aria-current')
      })
      if (previous) previous.disabled = !loop && index === 0
      if (next) next.disabled = !loop && index >= slideCount() - 1

      items.forEach((item, position) => {
        const active = position === index
        item.setAttribute('aria-hidden', active ? 'false' : 'true')
        if ('inert' in HTMLElement.prototype) item.inert = !active
        if (isFade) item.toggleAttribute('data-active', active)
      })

      const slideEl = slideOf(items[index])
      if (!slideEl) return

      const layout = slideEl.dataset.layout || ''
      if (layout) section.dataset.activeLayout = layout

      if (layout === 'split' && slideEl.dataset.media) {
        section.dataset.activeMedia = slideEl.dataset.media
      } else {
        section.removeAttribute('data-active-media')
      }

      if (!dotsContainer) return

      // `auto` is the old behaviour for content slides and the prototype's
      // white dots over an image; the other two are explicit overrides.
      if (!section.classList.contains('hero-carousel--dots-auto')) {
        dotsContainer.style.color = ''
        return
      }

      if (layout === 'image') {
        dotsContainer.style.color = '#fff'
        return
      }

      const mediaPanel = slideEl.querySelector('.hero-slide__media-panel')
      const reference = mediaPanel || slideEl
      const fg = getComputedStyle(reference).getPropertyValue('--color-foreground').trim()
      if (fg) dotsContainer.style.color = fg
    }

    const clampOrWrap = (index) => {
      const total = slideCount()
      if (total === 0) return 0
      if (loop && engine === 'transform') return ((index % total) + total) % total
      return Math.max(0, Math.min(index, total - 1))
    }

    const scrollIndex = () => {
      let closestIndex = 0
      let closestDistance = Number.POSITIVE_INFINITY
      points.forEach((point, index) => {
        const distance = Math.abs(track.scrollLeft - point)
        if (distance < closestDistance) {
          closestDistance = distance
          closestIndex = index
        }
      })
      return closestIndex
    }

    const currentIndex = () => (engine === 'transform' ? activeIndex : scrollIndex())

    const applyIndex = (index) => {
      if (engine !== 'transform') {
        const point = points[Math.max(0, Math.min(index, points.length - 1))]
        track.scrollTo({ left: point, behavior: 'smooth' })
        return
      }
      activeIndex = clampOrWrap(index)
      if (!isFade) track.style.transform = 'translateX(' + -activeIndex * 100 + '%)'
      setActive(activeIndex)
      syncHeight()
    }

    // `user` restarts the autoplay clock, the way the prototype's timer
    // resets whenever the reader moves a slide themselves.
    const goTo = (index, options) => {
      applyIndex(index)
      if (options && options.user) startAutoplay()
    }

    const stopAutoplay = () => {
      if (autoplayTimer) {
        clearInterval(autoplayTimer)
        autoplayTimer = null
      }
    }

    const startAutoplay = () => {
      if (!autoplayEnabled || reduceMotion || slideCount() < 2) return
      stopAutoplay()
      autoplayTimer = setInterval(() => {
        const nextIndex = currentIndex() + 1
        applyIndex(nextIndex >= slideCount() ? 0 : nextIndex)
      }, autoplayInterval)
    }

    // On mobile the slides are content-height (not stretched); pin the frame to the
    // active slide so a short slide doesn't inherit a taller slide's empty space.
    const syncHeight = () => {
      if (!frame) return
      if (isStage) {
        frame.style.height = ''
        return
      }
      if (!window.matchMedia('(max-width: 980px)').matches) {
        frame.style.height = ''
        return
      }
      const active = items[currentIndex()]
      if (active) frame.style.height = Math.ceil(active.getBoundingClientRect().height) + 'px'
    }

    const update = () => {
      if (engine === 'transform') {
        const hasSlides = items.length > 1
        section.classList.toggle('hero-carousel--has-overflow', hasSlides)
        dots.forEach((dot, index) => {
          dot.hidden = !hasSlides || index >= items.length
        })
        applyIndex(activeIndex)
        if (hasSlides) startAutoplay()
        else stopAutoplay()
        return
      }

      const trackStyle = getComputedStyle(track)
      const isSlider = trackStyle.overflowX === 'auto' || trackStyle.overflowX === 'scroll'
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth)
      const trackLeft = track.getBoundingClientRect().left
      points = items
        .map((item) => item.getBoundingClientRect().left - trackLeft + track.scrollLeft)
        .map((point) => Math.min(Math.max(0, point), maxScroll))
        .filter((point, index, values) => index === 0 || Math.abs(point - values[index - 1]) > 1)

      const hasOverflow = isSlider && maxScroll > 1 && points.length > 1
      section.classList.toggle('hero-carousel--has-overflow', hasOverflow)
      dots.forEach((dot, index) => {
        dot.hidden = !hasOverflow || index >= points.length
      })
      setActive(hasOverflow ? currentIndex() : 0)
      syncHeight()
      if (hasOverflow) startAutoplay()
      else stopAutoplay()
    }

    previous?.addEventListener('click', () => goTo(currentIndex() - 1, { user: true }))
    next?.addEventListener('click', () => goTo(currentIndex() + 1, { user: true }))
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index, { user: true })))

    if (engine === 'transform') {
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
        event.preventDefault()
        goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), { user: true })
      })
    }
    track.addEventListener('dragstart', (event) => event.preventDefault())
    track.addEventListener('pointerdown', (event) => {
      if (!swipeEnabled) return
      if (!section.classList.contains('hero-carousel--has-overflow')) return
      if (!event.isPrimary || event.button !== 0) return
      pointerId = event.pointerId
      pointerStartX = event.clientX
      pointerStartY = event.clientY
      pointerStartScroll = track.scrollLeft
      isDragging = false
      directionLocked = false
      suppressClick = false
    })
    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return
      const distanceX = event.clientX - pointerStartX
      const distanceY = event.clientY - pointerStartY

      if (!directionLocked) {
        if (Math.abs(distanceX) < 6 && Math.abs(distanceY) < 6) return
        directionLocked = true
        if (Math.abs(distanceY) >= Math.abs(distanceX)) return
        isDragging = true
        track.setPointerCapture(pointerId)
        track.classList.add('is-dragging')
      }

      if (!isDragging) return

      if (engine === 'transform') {
        // `touch-action: pan-y` already yields the horizontal gesture, so
        // there is nothing to preventDefault here.
        dragOffset = distanceX
        track.style.transform = 'translateX(calc(' + -activeIndex * 100 + '% + ' + dragOffset + 'px))'
        return
      }

      event.preventDefault()
      track.scrollLeft = pointerStartScroll - distanceX
    })

    const finishDrag = (event) => {
      if (event.pointerId !== pointerId) return
      if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId)
      pointerId = null
      if (!isDragging) return
      isDragging = false
      suppressClick = true
      track.classList.remove('is-dragging')

      if (engine === 'transform') {
        const moved = dragOffset
        dragOffset = 0
        if (Math.abs(moved) > swipeThreshold) goTo(activeIndex + (moved < 0 ? 1 : -1), { user: true })
        else applyIndex(activeIndex)
        setTimeout(() => {
          suppressClick = false
        }, 0)
        return
      }

      goTo(currentIndex())
      setTimeout(() => {
        suppressClick = false
      }, 0)
    }

    track.addEventListener('pointerup', finishDrag)
    track.addEventListener('pointercancel', finishDrag)
    track.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return
        event.preventDefault()
        event.stopPropagation()
      },
      true
    )
    track.addEventListener(
      'scroll',
      () =>
        requestAnimationFrame(() => {
          setActive(currentIndex())
          syncHeight()
        }),
      { passive: true }
    )

    section.addEventListener('pointerenter', stopAutoplay)
    section.addEventListener('pointerleave', startAutoplay)
    section.addEventListener('focusin', stopAutoplay)
    section.addEventListener('focusout', startAutoplay)

    const resizeObserver = new ResizeObserver(update)
    resizeObserver.observe(track)
    update()
  }

  document.querySelectorAll('[data-hero-carousel]').forEach(initializeHeroCarousel)
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-hero-carousel]')
    if (section) initializeHeroCarousel(section)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preview"]) return;
  try {
    
  /* ==========================================================================
   * Story Preview — hydration + interactions
   *
   * The personalization data comes from a backend "preview" API, fetched at
   * runtime by loadPreview() below — there is NO mock/placeholder data.
   * Until the backend responds, the story body stays hidden; only the sticky
   * buy bar (built from the real Shopify product) is shown. Expected shape:
   *
   *   { title, character, artStyle, pageCount,
   *     preview: [{ src, label, isCover? }], locked: [src...],
   *     rating, reviewCount, testimonial: { quote, author } }
   *
   * The purchasable product (formats/prices/stock) is NOT part of this — it is
   * the real Shopify product resolved from the URL handle (?product=<handle>).
   * No handle / unresolvable product → the not-found state (no body, no bar).
   * ======================================================================== */
  function initPreview(root) {
    if (!root || root.__previewInit) return;
    root.__previewInit = true;

    var $ = function (sel) { return root.querySelector(sel); };

    // Backend base URL (shared Story API setting). Root-relative asset URLs from
    // the payload (e.g. "/stories/emma/cover.png") are resolved against it so the
    // mock's images load cross-origin; blank base = same origin (App Proxy/prod).
    var apiBase = '';
    var proxyBase = '/apps';
    var sessionId = '';
    function assetUrl(u) {
      if (!u) return u;
      if (apiBase && u.charAt(0) === '/' && u.charAt(1) !== '/') return apiBase + u;
      return u;
    }

    var prevEl = root.querySelector('[data-prev]');
    var notFoundEl = root.querySelector('[data-notfound]');
    var noPrevEl = root.querySelector('[data-noprev]');
    var skeletonEl = root.querySelector('[data-skeleton]');

    function hideSkeleton() {
      if (skeletonEl) skeletonEl.hidden = true;
    }

    function showNotFound() {
      hideSkeleton();
      if (prevEl) prevEl.hidden = true;
      if (noPrevEl) noPrevEl.hidden = true;
      if (notFoundEl) notFoundEl.hidden = false;
    }

    // Product resolved (buy bar shown, still purchasable) but the preview data
    // didn't — reveal the "no preview" state instead of leaving the body blank.
    function showNoPreview() {
      hideSkeleton();
      if (prevEl) prevEl.hidden = true;
      if (notFoundEl) notFoundEl.hidden = true;
      if (noPrevEl) noPrevEl.hidden = false;
    }

    // Hydrate + reveal the preview body from backend `data`. Only called once
    // both the product and the preview data have resolved.
    function renderBody(data) {
      // No usable preview payload → show the no-preview state, not a blank body.
      if (!data || !data.preview || !data.preview.length) {
        showNoPreview();
        return;
      }
      hideSkeleton();
      if (noPrevEl) noPrevEl.hidden = true;
      if (prevEl) prevEl.hidden = false;

      // Personalization meta on the sticky buy bar (product provides the rest).
      var metaPrefix = $('[data-buy-meta-prefix]');
      // No art style (the story's own default was used) → drop the segment entirely
      // rather than print an empty "Art: ·".
      if (metaPrefix) {
        metaPrefix.textContent = (data.artStyle ? 'Art: ' + data.artStyle + ' · ' : '') + (data.pageCount || 0) + ' pages · ';
      }

    /* ---- hero ---- */
    $('[data-character]').textContent = data.character || '';
    // The subtitle reads "…painted in <style>." — with no style (the story's own
    // default was used) the " in <style>" clause drops out and the sentence still reads.
    var artEl = $('[data-art]');
    var artWrap = $('[data-art-wrap]');
    if (artEl) artEl.textContent = data.artStyle || '';
    if (artWrap) artWrap.hidden = !data.artStyle;

    /* ---- slideshow ---- */
    var stage = $('[data-stage]');
    var dotsWrap = $('[data-dots]');
    var labelEl = $('[data-label]');
    // NB: the slideshow arrows use their own classes, not [data-prev]/[data-next],
    // because [data-prev] is also on the .wb-prev container (would grab the wrong
    // node and break the arrows).
    var prevBtn = $('.wb-arrow--prev');
    var nextBtn = $('.wb-arrow--next');
    // Start on the cover.
    var index = 0;

    // Idempotent: clear before rebuild so a fresh-URL re-render doesn't duplicate.
    dotsWrap.innerHTML = '';
    data.preview.forEach(function (item, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'wb-prev-dot';
      dot.setAttribute('aria-label', item.label);
      dot.addEventListener('click', function () { go(i); });
      dotsWrap.appendChild(dot);
    });

    function renderSlide() {
      var item = data.preview[index];
      var old = stage.querySelector('.wb-prev-pane');
      if (old) old.remove();
      var pane = document.createElement('div');
      pane.className = 'wb-prev-pane';
      var img = document.createElement('img');
      img.className = 'wb-prev-img';
      img.src = item.src;
      img.alt = data.title + ' — ' + item.label;
      pane.appendChild(img);
      stage.insertBefore(pane, stage.firstChild);
      stage.classList.toggle('is-cover', !!item.isCover);
      labelEl.textContent = item.label;
      var dots = dotsWrap.children;
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('on', d === index);
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index === data.preview.length - 1;
    }
    function go(i) {
      index = Math.max(0, Math.min(data.preview.length - 1, i));
      renderSlide();
    }
    prevBtn.addEventListener('click', function () { go(index - 1); });
    nextBtn.addEventListener('click', function () { go(index + 1); });
    renderSlide();

    /* ---- list ---- */
    var cards = $('[data-cards]');
    cards.innerHTML = '';
    data.preview.forEach(function (item) {
      var fig = document.createElement('figure');
      fig.className = 'wb-prev-card' + (item.isCover ? ' is-cover' : '');
      var page = document.createElement('div');
      page.className = 'wb-prev-page' + (item.isCover ? ' is-cover' : '');
      var pane = document.createElement('div');
      pane.className = 'wb-prev-pane';
      var img = document.createElement('img');
      img.className = 'wb-prev-img';
      img.loading = 'lazy';
      img.src = item.src;
      img.alt = data.title + ' — ' + item.label;
      pane.appendChild(img);
      page.appendChild(pane);
      if (item.isCover) {
        var ribbon = document.createElement('span');
        ribbon.className = 'wb-prev-ribbon';
        ribbon.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v6m0 6v6m-9-9h6m6 0h6"></path></svg> ';
        ribbon.appendChild(document.createTextNode((data.character || 'Your child') + ' is the star'));
        page.appendChild(ribbon);
      }
      fig.appendChild(page);
      var cap = document.createElement('figcaption');
      cap.className = 'wb-prev-label';
      cap.textContent = item.label;
      fig.appendChild(cap);
      cards.appendChild(fig);
    });

    /* ---- mode toggle ---- */
    var show = $('[data-show]');
    var modeBtns = root.querySelectorAll('[data-mode]');
    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.dataset.mode;
        modeBtns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var showMode = mode === 'show';
        show.hidden = !showMode;
        cards.hidden = showMode;
      });
    });

    /* ---- locked grid ----
       One thumb per remaining (locked) page — every page beyond the teaser, so
       the grid count = pageCount − teaser (mirrors the design's pageImages[2:]).
       When there are none, fall back to 3 empty boxes so the gate has a backdrop. */
    var lockedRow = $('[data-locked]');
    lockedRow.innerHTML = '';
    var lockedSrcs = (data.locked && data.locked.length) ? data.locked : [null, null, null];
    lockedSrcs.forEach(function (src) {
      var thumb = document.createElement('div');
      thumb.className = 'wb-locked-thumb';
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.loading = 'lazy';
        thumb.appendChild(img);
      }
      lockedRow.appendChild(thumb);
    });
    $('[data-lock-title]').textContent = 'Buy the book to read all ' + data.pageCount + ' pages';
    $('[data-lock-sub]').textContent = 'Cover plus ' + data.pageCount + ' pages, each illustrated for your child';

    /* Social proof is static content rendered from section settings (see the
       .wb-proof block in the markup) — nothing to hydrate here. */
    }
    /* ---- end renderBody ---- */

    /* ------------------------------------------------------------------
     * Sticky buy bar. The product handle comes from the URL (?product=<handle>).
     * We fetch /products/{handle}.js (Ajax API) and build the format radios from
     * the product's REAL variants (title / price / availability / variant.id).
     * Add to cart is a real <form> submit that the theme header intercepts
     * (form[action$="/cart/add"]) → /cart/add.js + mini-cart. Buy now adds then
     * routes to /checkout. Only the "Art · N pages" meta prefix is personalization.
     *
     * NO PRODUCT = NO BAR. If there is no handle, the fetch fails, or the product
     * has no variants, the buy bar stays hidden — there is no mock/fallback.
     * ---------------------------------------------------------------- */
    var buyForm = root.querySelector('[data-buy]');
    var coverImg = root.querySelector('[data-buy-cover]');
    var titleEl = root.querySelector('[data-buy-title]');
    var stockEl = root.querySelector('[data-buy-stock]');
    var fmtsWrap = root.querySelector('[data-fmts]');
    var variantInput = root.querySelector('[data-variant-input]');
    var atcBtn = root.querySelector('[data-atc]');
    var buyNowBtn = root.querySelector('[data-buynow]');
    var selectedId = null;

    function moneyFromCents(cents) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    }

    function pick(fmt, btn) {
      [].forEach.call(fmtsWrap.children, function (b) {
        var on = b === btn;
        b.classList.toggle('on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      selectedId = fmt.id;
      variantInput.value = fmt.id || '';
      var available = !!fmt.available;
      atcBtn.disabled = !available;
      if (buyNowBtn) buyNowBtn.disabled = !available;
      // Also drive the visual state with a class (don't rely on the :disabled
      // pseudo alone) and reflect sold-out in the button label.
      atcBtn.classList.toggle('is-disabled', !available);
      if (buyNowBtn) buyNowBtn.classList.toggle('is-disabled', !available);
      // Both labels are merchant settings, carried on the button itself.
      atcBtn.textContent = available
        ? (atcBtn.dataset.label || 'Add to cart')
        : (atcBtn.dataset.labelSoldout || 'Sold out');
      stockEl.textContent = available ? 'In stock' : 'Sold out';
      stockEl.style.color = available ? 'var(--wb-green)' : 'var(--wb-sharpie-60)';
      stockEl.style.fontWeight = available ? '600' : '400';
    }

    function showBuyBar(product) {
      titleEl.textContent = product.title || '';
      var coverSrc = product.featured_image || (product.images && product.images[0]) || '';
      if (coverSrc) { coverImg.src = coverSrc; coverImg.alt = product.title || ''; }
      else { coverImg.remove(); }
      // The "Art: … · N pages" meta prefix is personalization and is filled by
      // renderBody() once the backend data loads.

      var formats = product.variants.map(function (v) {
        return { id: v.id, title: v.title, available: v.available, priceText: moneyFromCents(v.price) };
      });
      // The edition chosen during the wait wins, as long as it is still
      // purchasable: it arrives as ?variant= from the Generating page, with
      // sessionStorage as the fallback for a reload that dropped the param.
      var wantedVariant = params.get('variant') || '';
      if (!wantedVariant) {
        try { wantedVariant = sessionStorage.getItem('dreamstory:format:' + handle) || ''; } catch (e) { wantedVariant = ''; }
      }
      var chosen = null;
      for (var i = 0; i < formats.length; i++) {
        if (formats[i].available) {
          if (String(formats[i].id) === String(wantedVariant)) { chosen = formats[i]; break; }
          if (!chosen) chosen = formats[i];
        }
      }
      if (!chosen) chosen = formats[0];
      formats.forEach(function (fmt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('role', 'radio');
        var on = fmt === chosen;
        btn.className = 'wb-buy-fmt' + (on ? ' on' : '');
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        btn.innerHTML = '<span class="t"></span><span class="p"></span>';
        btn.querySelector('.t').textContent = fmt.title;
        btn.querySelector('.p').textContent = fmt.priceText;
        fmt._btn = btn;
        btn.addEventListener('click', function () { pick(fmt, btn); });
        fmtsWrap.appendChild(btn);
      });
      pick(chosen, chosen._btn);

      // Buy now: add the selected variant, then go straight to checkout. The
      // button is optional — the merchant can turn it off in the theme editor.
      if (buyNowBtn) buyNowBtn.addEventListener('click', function () {
        if (buyNowBtn.disabled || !selectedId) return;
        buyNowBtn.disabled = true;
        var item = { id: Number(selectedId), quantity: 1 };
        if (sessionId) item.properties = { _ai_stories_next_session_id: sessionId };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () { window.location.assign('/checkout'); })
          .catch(function () { buyNowBtn.disabled = false; });
      });
      // Add to cart: do the /cart/add.js POST ourselves (don't depend on the
      // theme header intercepting the native form submit). We preventDefault so
      // there is no double add, then notify the header to refresh the mini-cart.
      buyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atcBtn.disabled || !selectedId) return;
        atcBtn.classList.add('is-loading');
        atcBtn.disabled = true;
        var item = { id: Number(selectedId), quantity: 1 };
        if (sessionId) item.properties = { _ai_stories_next_session_id: sessionId };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:update'));
            atcBtn.classList.remove('is-loading');
            atcBtn.disabled = false;
          })
          .catch(function () {
            atcBtn.classList.remove('is-loading');
            atcBtn.disabled = false;
          });
      });

      buyForm.hidden = false;
      root.classList.add('has-buy');
    }

    // Map the backend /generate payload onto the shape renderBody() expects.
    //   generate → { childName, artStyle, cover:{url}, teaserPages:[{pageNo,url}],
    //               totalPages, lockedThumbs:[url] }
    //   renderBody → { title, character, artStyle, pageCount,
    //               preview:[{src,label,isCover}], locked:[src] }
    function mapPreview(payload, product) {
      var slides = [];
      if (payload.cover && payload.cover.url) slides.push({ src: assetUrl(payload.cover.url), label: 'Cover', isCover: true });
      (payload.teaserPages || []).forEach(function (t) {
        slides.push({ src: assetUrl(t.url), label: 'Page ' + t.pageNo });
      });
      return {
        title: (product && product.title) || payload.title || '',
        character: payload.childName || payload.character || '',
        artStyle: payload.artStyle || '',
        pageCount: payload.totalPages || payload.pageCount || 0,
        preview: slides,
        locked: (payload.lockedThumbs || payload.locked || []).map(assetUrl)
        // No social proof in the generate payload → the proof band stays hidden
        // (renderBody guards it). A real backend can add rating/testimonial here.
      };
    }

    // Personalisation data seam. The book is produced by the Generating page
    // (POST {api_base}/bff/v1/generate, SSE), which stores the resulting payload
    // for this product before redirecting here — the multi-page equivalent of the
    // prototype passing it via in-memory state. We read that handoff and map it.
    //
    // TODO(backend): when a GET preview endpoint exists, fetch it here as a
    // fallback (via the fixed `/apps` App Proxy base) for deep links that
    // arrive without a prior generate — until then, no handoff = the no-preview
    // state (the sticky buy bar for the real product still shows).
    // The cached payload (from the Generating page) carries SIGNED image URLs that
    // expire after 15 min (§9). It is only good for an instant first paint — never
    // as the lasting source of image URLs. So whenever we have a session_id we MUST
    // re-read the session for freshly signed URLs, otherwise the shopper is left
    // staring at expired (broken) images with no refresh.
    function readCachedPreview(productHandle, product) {
      var raw = null;
      try { raw = sessionStorage.getItem('dreamstory:preview:' + productHandle); } catch (e) { /* private mode */ }
      if (!raw) return null;
      try { return mapPreview(JSON.parse(raw), product); } catch (e) { return null; }
    }

    function fetchSessionPreview(product) {
      return fetch(proxyBase + '/upsell?queryType=ai-stories-next-session&id=' + encodeURIComponent(sessionId), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (res) {
          var p = res && res.data && res.data.preview;
          if (!p) return Promise.reject(new Error('no preview'));
          return mapPreview(p, product);
        });
    }

    function loadPreview(productHandle, product) {
      // Network-first when we have a session_id: re-read for freshly signed URLs
      // (§9) instead of the cached, soon-to-expire ones. The skeleton shows during
      // the fetch; the cached payload is used only if the refresh fails, so a
      // transient error still paints something rather than nothing.
      if (sessionId && proxyBase) {
        fetchSessionPreview(product)
          .then(function (data) { renderBody(data); })
          .catch(function () {
            var cached = readCachedPreview(productHandle, product);
            if (cached) renderBody(cached); else showNoPreview();
          });
        return;
      }
      var cached = readCachedPreview(productHandle, product);
      if (cached) renderBody(cached); else showNoPreview();
    }

    var params = new URLSearchParams(location.search);
    var handle = params.get('product') || params.get('handle') || params.get('product_handle');
    sessionId = params.get('session') || '';
    var sessionPropInput = root.querySelector('[data-session-prop]');
    if (sessionPropInput) sessionPropInput.value = sessionId;
    if (!handle) {
      // No handle → show only the not-found state (no preview body, no buy bar).
      showNotFound();
      return;
    }
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) {
          // No / unresolvable / unpurchasable product → not found.
          showNotFound();
          return;
        }
        // Real product resolved → build the buy bar, then load the story body
        // from the backend. No backend / no data → the no-preview state (buy bar
        // still shows).
        showBuyBar(p);
        loadPreview(handle, p);
      })
      .catch(function () { showNotFound(); });
  }

  function initAllPreviews(scope) {
    (scope || document).querySelectorAll('[data-preview]').forEach(initPreview);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllPreviews(); });
  } else {
    initAllPreviews();
  }
  document.addEventListener('shopify:section:load', function (e) { initAllPreviews(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  function initializeProductList(section) {
    const track = section.querySelector('.product-list__items')
    const items = Array.from(section.querySelectorAll('.product-list__item'))
    const previous = section.querySelector('[data-slider-previous]')
    const next = section.querySelector('[data-slider-next]')
    const dots = Array.from(section.querySelectorAll('[data-slide-index]'))
    let points = []
    let pointerId = null
    let pointerStartX = 0
    let pointerStartY = 0
    let pointerStartScroll = 0
    let isDragging = false
    let directionLocked = false
    let suppressClick = false

    if (!track || items.length === 0) return

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true')
        else dot.removeAttribute('aria-current')
      })
      if (previous) previous.disabled = index === 0
      if (next) next.disabled = index >= points.length - 1
    }

    const currentIndex = () => {
      let closestIndex = 0
      let closestDistance = Number.POSITIVE_INFINITY
      points.forEach((point, index) => {
        const distance = Math.abs(track.scrollLeft - point)
        if (distance < closestDistance) {
          closestDistance = distance
          closestIndex = index
        }
      })
      return closestIndex
    }

    const goTo = (index) => {
      const point = points[Math.max(0, Math.min(index, points.length - 1))]
      track.scrollTo({ left: point, behavior: 'smooth' })
    }

    const update = () => {
      const trackStyle = getComputedStyle(track)
      const isSlider = trackStyle.overflowX === 'auto' || trackStyle.overflowX === 'scroll'
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth)
      const trackLeft = track.getBoundingClientRect().left
      points = items
        .map((item) => item.getBoundingClientRect().left - trackLeft + track.scrollLeft)
        .map((point) => Math.min(Math.max(0, point), maxScroll))
        .filter((point, index, values) => index === 0 || Math.abs(point - values[index - 1]) > 1)

      const hasOverflow = isSlider && maxScroll > 1 && points.length > 1
      section.classList.toggle('product-list--has-overflow', hasOverflow)
      dots.forEach((dot, index) => {
        dot.hidden = !hasOverflow || index >= points.length
      })
      setActive(hasOverflow ? currentIndex() : 0)
    }

    previous?.addEventListener('click', () => goTo(currentIndex() - 1))
    next?.addEventListener('click', () => goTo(currentIndex() + 1))
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)))
    track.addEventListener('dragstart', (event) => event.preventDefault())
    track.addEventListener('pointerdown', (event) => {
      if (!section.classList.contains('product-list--has-overflow')) return
      if (!event.isPrimary || event.button !== 0) return
      pointerId = event.pointerId
      pointerStartX = event.clientX
      pointerStartY = event.clientY
      pointerStartScroll = track.scrollLeft
      isDragging = false
      directionLocked = false
      suppressClick = false
    })
    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return
      const distanceX = event.clientX - pointerStartX
      const distanceY = event.clientY - pointerStartY

      if (!directionLocked) {
        if (Math.abs(distanceX) < 6 && Math.abs(distanceY) < 6) return
        directionLocked = true
        if (Math.abs(distanceY) >= Math.abs(distanceX)) return
        isDragging = true
        track.setPointerCapture(pointerId)
        track.classList.add('is-dragging')
      }

      if (!isDragging) return
      event.preventDefault()
      track.scrollLeft = pointerStartScroll - distanceX
    })

    const finishDrag = (event) => {
      if (event.pointerId !== pointerId) return
      if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId)
      pointerId = null
      if (!isDragging) return
      isDragging = false
      suppressClick = true
      track.classList.remove('is-dragging')
      goTo(currentIndex())
      setTimeout(() => {
        suppressClick = false
      }, 0)
    }

    track.addEventListener('pointerup', finishDrag)
    track.addEventListener('pointercancel', finishDrag)
    track.addEventListener('click', (event) => {
      if (!suppressClick) return
      event.preventDefault()
      event.stopPropagation()
    }, true)
    track.addEventListener('scroll', () => requestAnimationFrame(() => setActive(currentIndex())), { passive: true })
    const resizeObserver = new ResizeObserver(update)
    resizeObserver.observe(track)
    update()
  }

  document.querySelectorAll('[data-product-list]').forEach(initializeProductList)
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-product-list]')
    if (section) initializeProductList(section)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review"] && !Shopify.designMode) return;
  try {
    
  function initializeReviewShowcase(root) {
    if (root.dataset.reviewReady === 'true') return
    root.dataset.reviewReady = 'true'

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const frameMs = Math.max(600, parseInt(root.dataset.frameMs || '2400', 10))
    const spotMs = Math.max(2000, parseInt(root.dataset.spotlightMs || '8000', 10))
    const countMs = Math.max(200, parseInt(root.dataset.countMs || '1400', 10))
    const teardown = []

    const observe = (targets, threshold, once, onChange) => {
      if (targets.length === 0) return
      if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => onChange(el, true))
        return
      }
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            onChange(entry.target, entry.isIntersecting)
            if (once && entry.isIntersecting) observer.unobserve(entry.target)
          })
        },
        { threshold }
      )
      targets.forEach((el) => observer.observe(el))
      teardown.push(() => observer.disconnect())
    }

    /* ---------- clips: still frames that cross-fade and pan ---------- */
    const clips = new Map()

    Array.from(root.querySelectorAll('[data-review-clip]')).forEach((clip) => {
      const frames = Array.from(clip.querySelectorAll('.review-media__frame'))
      const bars = Array.from(clip.querySelectorAll('.review-media__bars span'))
      let index = 0
      let timer = null

      const paint = () => {
        frames.forEach((frame, n) => frame.classList.toggle('is-current', n === index))
        bars.forEach((bar, n) => {
          bar.classList.toggle('is-done', n < index)
          bar.classList.toggle('is-running', n === index)
        })
      }

      const stop = () => {
        if (timer) {
          clearInterval(timer)
          timer = null
        }
        clip.classList.remove('is-playing')
      }

      const play = () => {
        clip.classList.add('is-playing')
        if (timer) return
        if (reduceMotion) return
        if (frames.length < 2) return
        timer = setInterval(() => {
          index = (index + 1) % frames.length
          paint()
        }, frameMs)
      }

      clips.set(clip, { play, stop })
      teardown.push(stop)
    })

    const mediaIn = (scope) => {
      if (!scope) return null
      if (scope.matches('[data-review-clip]')) return scope
      if (scope.matches('video')) return scope
      return scope.querySelector('[data-review-clip], video')
    }

    const playMedia = (scope) => {
      const el = mediaIn(scope)
      if (!el) return
      if (el.tagName === 'VIDEO') {
        const attempt = el.play()
        if (attempt) attempt.catch(() => {})
        return
      }
      const clip = clips.get(el)
      if (clip) clip.play()
    }

    const pauseMedia = (scope) => {
      const el = mediaIn(scope)
      if (!el) return
      if (el.tagName === 'VIDEO') {
        el.pause()
        return
      }
      const clip = clips.get(el)
      if (clip) clip.stop()
    }

    /* ---------- section reveal ---------- */
    observe([root], 0.1, true, (el, visible) => {
      if (visible) el.classList.add('is-visible')
    })

    /* ---------- view switcher ---------- */
    const views = Array.from(root.querySelectorAll('[data-review-view]'))
    const tabs = Array.from(root.querySelectorAll('[data-review-tab]'))
    const tabStrip = root.querySelector('.review-showcase__views')

    const showView = (name) => {
      root.dataset.view = name
      views.forEach((view) => {
        const active = view.dataset.reviewView === name
        view.hidden = !active
        if (!active) {
          Array.from(view.querySelectorAll('[data-review-clip], video')).forEach(pauseMedia)
          return
        }
        view.classList.remove('review-showcase__view')
        void view.offsetWidth
        view.classList.add('review-showcase__view')
      })
      tabs.forEach((tab, position) => {
        const active = tab.dataset.reviewTab === name
        tab.classList.toggle('is-active', active)
        tab.setAttribute('aria-selected', active ? 'true' : 'false')
        if (active && tabStrip) tabStrip.style.setProperty('--x', position)
      })
    }

    tabs.forEach((tab) => {
      const handler = () => showView(tab.dataset.reviewTab)
      tab.addEventListener('click', handler)
      teardown.push(() => tab.removeEventListener('click', handler))
    })

    /* ---------- summary ---------- */
    const summary = root.querySelector('[data-review-summary]')
    const score = root.querySelector('[data-review-count-to]')

    const countUp = () => {
      if (!score) return
      const target = parseFloat(score.dataset.reviewCountTo || '0')
      if (root.dataset.countUp !== 'true' || reduceMotion) {
        score.textContent = target.toFixed(1)
        return
      }
      const started = performance.now()
      const step = (now) => {
        const k = Math.min(1, (now - started) / countMs)
        const eased = 1 - Math.pow(1 - k, 3)
        score.textContent = (target * eased).toFixed(1)
        if (k < 1) requestAnimationFrame(step)
      }
      requestAnimationFrame(step)
    }

    if (summary) {
      observe([summary], 0.3, true, (el, visible) => {
        if (!visible) return
        el.classList.add('is-visible')
        countUp()
      })
    }

    /* ---------- wall: reveal, filter, helpful ---------- */
    const wall = root.querySelector('[data-review-wall]')
    const cards = Array.from(root.querySelectorAll('[data-review-card]'))
    const empty = root.querySelector('[data-review-empty]')

    const hostOf = (card) => {
      if (!wall) return card
      let node = card
      while (node.parentElement && node.parentElement !== wall) node = node.parentElement
      return node
    }

    const hosts = new Map(cards.map((card) => [card, hostOf(card)]))

    observe(cards, 0.12, true, (el, visible) => {
      if (visible) el.classList.add('is-visible')
    })

    const chips = Array.from(root.querySelectorAll('[data-review-filter]'))

    const applyFilter = (name) => {
      let shown = 0
      cards.forEach((card) => {
        const photos = parseInt(card.dataset.reviewPhotos || '0', 10)
        const videos = parseInt(card.dataset.reviewVideos || '0', 10)
        const rating = parseFloat(card.dataset.reviewRating || '0')
        let match = true
        if (name === 'photo') match = photos > 0
        if (name === 'video') match = videos > 0
        if (name === 'five') match = rating === 5
        const host = hosts.get(card)
        if (host) host.hidden = !match
        if (match) shown += 1
      })
      if (empty) empty.hidden = shown > 0

      cards.forEach((card) => {
        const host = hosts.get(card)
        if (host && host.hidden) return
        card.classList.remove('is-visible')
      })
      requestAnimationFrame(() => {
        cards.forEach((card) => {
          const host = hosts.get(card)
          if (host && host.hidden) return
          card.classList.add('is-visible')
        })
      })
    }

    chips.forEach((chip) => {
      const handler = () => {
        chips.forEach((other) => {
          const active = other === chip
          other.classList.toggle('is-active', active)
          other.setAttribute('aria-pressed', active ? 'true' : 'false')
        })
        applyFilter(chip.dataset.reviewFilter)
      }
      chip.addEventListener('click', handler)
      teardown.push(() => chip.removeEventListener('click', handler))
    })

    Array.from(root.querySelectorAll('[data-review-helpful]')).forEach((button) => {
      const value = button.querySelector('[data-review-helpful-value]')
      const base = parseInt(button.dataset.reviewHelpfulCount || '0', 10)
      const handler = () => {
        const liked = button.getAttribute('aria-pressed') !== 'true'
        button.setAttribute('aria-pressed', liked ? 'true' : 'false')
        if (value) value.textContent = liked ? base + 1 : base
      }
      button.addEventListener('click', handler)
      teardown.push(() => button.removeEventListener('click', handler))
    })

    Array.from(root.querySelectorAll('.review-card [data-review-thumb]')).forEach((thumb) => {
      const enter = () => playMedia(thumb)
      const leave = () => pauseMedia(thumb)
      thumb.addEventListener('pointerenter', enter)
      thumb.addEventListener('pointerleave', leave)
      teardown.push(() => {
        thumb.removeEventListener('pointerenter', enter)
        thumb.removeEventListener('pointerleave', leave)
      })
    })

    /* ---------- card media: carousel ---------- */
    Array.from(root.querySelectorAll('[data-review-carousel]')).forEach((carousel) => {
      const track = carousel.querySelector('[data-review-media-track]')
      const dots = Array.from(carousel.querySelectorAll('[data-review-carousel-dot]'))
      if (!track || dots.length === 0) return
      const items = Array.from(track.children)

      const sync = () => {
        let closest = 0
        let shortest = Number.POSITIVE_INFINITY
        items.forEach((item, n) => {
          const distance = Math.abs(item.offsetLeft - track.scrollLeft)
          if (distance < shortest) {
            shortest = distance
            closest = n
          }
        })
        dots.forEach((dot, n) => {
          if (n === closest) dot.setAttribute('aria-current', 'true')
          else dot.removeAttribute('aria-current')
        })
      }

      const onScroll = () => requestAnimationFrame(sync)
      track.addEventListener('scroll', onScroll, { passive: true })
      dots.forEach((dot, n) =>
        dot.addEventListener('click', () => {
          const item = items[n]
          if (item) track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' })
        })
      )
      teardown.push(() => track.removeEventListener('scroll', onScroll))
      sync()
    })

    /* ---------- card media: story ---------- */
    Array.from(root.querySelectorAll('[data-review-story]')).forEach((story) => {
      const track = story.querySelector('[data-review-media-track]')
      if (!track) return
      const items = Array.from(track.children)
      const bars = Array.from(story.querySelectorAll('.review-card__bars span'))
      const storyMs = Math.max(1000, parseInt(story.dataset.reviewStory || '4000', 10))
      let index = 0
      let inView = false
      let paused = false
      let timer = null

      const paint = () => {
        items.forEach((item, n) => {
          const active = n === index
          item.classList.toggle('is-current', active)
          if (active) playMedia(item)
          else pauseMedia(item)
        })
        bars.forEach((bar, n) => {
          bar.classList.toggle('is-done', n < index)
          bar.classList.toggle('is-running', n === index)
        })
        // Re-trigger the running bar's fill, which otherwise keeps the
        // progress it had when the class last landed on it.
        const fill = bars[index] ? bars[index].querySelector('i') : null
        if (fill) {
          fill.style.animation = 'none'
          void fill.offsetWidth
          fill.style.animation = ''
        }
      }

      const stop = () => {
        if (timer) {
          clearInterval(timer)
          timer = null
        }
      }

      const start = () => {
        stop()
        if (reduceMotion || paused || !inView) return
        if (items.length < 2) return
        timer = setInterval(() => {
          index = (index + 1) % items.length
          paint()
        }, storyMs)
      }

      observe([story], 0.4, false, (el, visible) => {
        inView = visible
        if (visible) start()
        else stop()
      })

      const enter = () => {
        paused = true
        stop()
      }
      const leave = () => {
        paused = false
        start()
      }
      story.addEventListener('pointerenter', enter)
      story.addEventListener('pointerleave', leave)
      teardown.push(() => {
        stop()
        story.removeEventListener('pointerenter', enter)
        story.removeEventListener('pointerleave', leave)
      })

      paint()
    })

    /* ---------- spotlight ---------- */
    const spotlight = root.querySelector('[data-review-spotlight]')

    if (spotlight) {
      const slides = Array.from(spotlight.querySelectorAll('[data-review-slide]'))
      const panels = Array.from(spotlight.querySelectorAll('[data-review-panel]'))
      const strips = Array.from(spotlight.querySelectorAll('[data-review-strip]'))
      const people = Array.from(spotlight.querySelectorAll('[data-review-person]'))
      const autoplay = root.dataset.spotlightAutoplay === 'true'
      let index = 0
      let inView = false
      let paused = false
      let timer = null

      const stop = () => {
        if (timer) {
          clearTimeout(timer)
          timer = null
        }
      }

      const schedule = () => {
        stop()
        if (!autoplay || reduceMotion || slides.length < 2) return
        if (!inView || paused) return
        timer = setTimeout(() => show(index + 1), spotMs)
      }

      const show = (next) => {
        const total = slides.length
        if (total === 0) return
        index = ((next % total) + total) % total

        slides.forEach((slide, n) => {
          const active = n === index
          slide.classList.toggle('is-active', active)
          slide.setAttribute('aria-hidden', active ? 'false' : 'true')
          slide.tabIndex = active ? 0 : -1
          if (active) playMedia(slide)
          else pauseMedia(slide)
        })

        panels.forEach((panel, n) => {
          panel.hidden = n !== index
          panel.classList.toggle('is-active', n === index)
        })
        strips.forEach((strip) => {
          strip.hidden = strip.dataset.reviewStrip !== String(index)
        })

        people.forEach((person, n) => {
          const active = n === index
          person.classList.toggle('is-active', active)
          person.classList.remove('is-running')
          if (!active) return
          const ring = person.querySelector('.review-spotlight__ring')
          if (ring) void ring.getBoundingClientRect().width
          if (autoplay && !reduceMotion && inView && !paused) person.classList.add('is-running')
        })

        schedule()
      }

      observe([spotlight], 0.35, false, (el, visible) => {
        inView = visible
        if (visible) show(index)
        else stop()
      })

      const enter = () => {
        paused = true
        stop()
        people.forEach((person) => person.classList.remove('is-running'))
      }
      const leave = () => {
        paused = false
        show(index)
      }
      spotlight.addEventListener('pointerenter', enter)
      spotlight.addEventListener('pointerleave', leave)
      spotlight.addEventListener('focusin', enter)
      spotlight.addEventListener('focusout', leave)
      teardown.push(() => {
        stop()
        spotlight.removeEventListener('pointerenter', enter)
        spotlight.removeEventListener('pointerleave', leave)
        spotlight.removeEventListener('focusin', enter)
        spotlight.removeEventListener('focusout', leave)
      })

      const previous = root.querySelector('[data-review-spot-previous]')
      const next = root.querySelector('[data-review-spot-next]')
      previous?.addEventListener('click', () => show(index - 1))
      next?.addEventListener('click', () => show(index + 1))
      people.forEach((person, n) => person.addEventListener('click', () => show(n)))
    }

    /* ---------- reels ---------- */
    const reelsTrack = root.querySelector('[data-review-reels-track]')

    if (reelsTrack) {
      const reels = Array.from(root.querySelectorAll('[data-review-reel]'))
      const autoplay = root.dataset.reelsAutoplay === 'true'

      if (autoplay) {
        observe(reels, 0.7, false, (el, visible) => {
          el.classList.toggle('is-playing', visible)
          if (visible) playMedia(el)
          else pauseMedia(el)
        })
      }

      const previous = root.querySelector('[data-review-reels-previous]')
      const next = root.querySelector('[data-review-reels-next]')
      const nudge = (direction) =>
        reelsTrack.scrollBy({ left: reelsTrack.clientWidth * 0.8 * direction, behavior: 'smooth' })
      previous?.addEventListener('click', () => nudge(-1))
      next?.addEventListener('click', () => nudge(1))
    }

    /* ---------- lightbox ---------- */
    Array.from(root.querySelectorAll('[data-review-lightbox]')).forEach((dialog) => {
      const items = Array.from(dialog.querySelectorAll('[data-review-lb-media]'))
      const thumbs = Array.from(dialog.querySelectorAll('[data-review-lb-thumb]'))
      const playButton = dialog.querySelector('[data-review-lb-play]')
      const closeButton = dialog.querySelector('[data-review-lb-close]')
      let index = 0
      let playing = true

      const show = (next) => {
        const total = items.length
        if (total === 0) return
        index = ((next % total) + total) % total
        items.forEach((item, n) => {
          const active = n === index
          item.hidden = !active
          item.classList.toggle('is-active', active)
          if (!active) pauseMedia(item)
        })
        thumbs.forEach((thumb, n) => thumb.classList.toggle('is-active', n === index))

        const current = items[index]
        const moving = current && current.dataset.reviewLbPlayable === 'true'
        if (playButton) playButton.hidden = !moving
        if (moving && playing) playMedia(current)
      }

      const setPlaying = (next) => {
        playing = next
        const current = items[index]
        if (playing) playMedia(current)
        else pauseMedia(current)
        if (!playButton) return
        playButton.setAttribute('aria-pressed', playing ? 'true' : 'false')
        const label = playing ? playButton.dataset.labelPause : playButton.dataset.labelPlay
        if (label) playButton.setAttribute('aria-label', label)
      }

      dialog.querySelector('[data-review-lb-previous]')?.addEventListener('click', () => show(index - 1))
      dialog.querySelector('[data-review-lb-next]')?.addEventListener('click', () => show(index + 1))
      thumbs.forEach((thumb, n) => thumb.addEventListener('click', () => show(n)))
      playButton?.addEventListener('click', () => setPlaying(!playing))
      closeButton?.addEventListener('click', () => dialog.close())

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close()
      })

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault()
          show(index + 1)
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault()
          show(index - 1)
        }
        if (event.key === ' ') {
          event.preventDefault()
          setPlaying(!playing)
        }
      })

      dialog.addEventListener('close', () => {
        items.forEach(pauseMedia)
      })

      dialog.__reviewShow = show
      teardown.push(() => items.forEach(pauseMedia))
    })

    Array.from(root.querySelectorAll('[data-review-open]')).forEach((opener) => {
      const handler = () => {
        const dialog = root.querySelector('#' + opener.dataset.reviewOpen)
        if (!dialog) return
        if (typeof dialog.showModal !== 'function') return
        dialog.showModal()
        if (dialog.__reviewShow) dialog.__reviewShow(parseInt(opener.dataset.reviewAt || '0', 10))
      }
      opener.addEventListener('click', handler)
      teardown.push(() => opener.removeEventListener('click', handler))
    })

    root.__reviewTeardown = () => {
      teardown.forEach((fn) => fn())
      root.dataset.reviewReady = 'false'
    }
  }

  document.querySelectorAll('[data-review-showcase]').forEach(initializeReviewShowcase)

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-review-showcase]')
    if (root) initializeReviewShowcase(root)
  })

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-review-showcase]')
    if (root && root.__reviewTeardown) root.__reviewTeardown()
  })

  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('[data-review-card]')
    if (!card) return
    const root = card.closest('[data-review-showcase]')
    if (!root) return
    const wallTab = root.querySelector('[data-review-tab="wall"]')
    if (wallTab) wallTab.click()
    card.scrollIntoView({ behavior: 'smooth', block: 'center' })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  function initSearch(root) {
    if (!root || root.dataset.searchInit === 'true') return
    root.dataset.searchInit = 'true'

    var tabs = root.querySelectorAll('[data-type-tab]')
    if (!tabs.length) return

    var current = 'all'
    try {
      current = new URLSearchParams(window.location.search).get('type') || 'all'
    } catch (error) {
      current = 'all'
    }

    tabs.forEach(function (tab) {
      if (tab.dataset.typeTab === current) {
        tab.classList.add('is-active')
        tab.setAttribute('aria-current', 'page')
      }
    })
  }

  document.querySelectorAll('[data-search]').forEach(initSearch)
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-search]')
    if (section) initSearch(section)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-product"] && !Shopify.designMode) return;
  try {
    
  function initStoryProduct(root) {
    if (!root || root.__storyInit) return;
    root.__storyInit = true;

    var handle = root.dataset.storyHandle || '';
    var previewUrl = root.dataset.previewUrl || '';
    var generatingUrl = root.dataset.generatingUrl || '';
    var mockStoryId = root.dataset.storyId || '';

    var proxyBase = '/apps';
    var apiBase = proxyBase; // kept for legacy references below
    var boundArtStyle = root.dataset.artStyle || '';
    var boundTeaser = root.dataset.teaser || '';

    // Faceswap end_user_id: a logged-in customer is identified by the signed
    // `logged_in_customer_id` the App Proxy adds server-side, so we must NOT send a
    // guest id then (it would fight the trusted customer id). Only anonymous
    // shoppers get a stable guest id (photo + generation must share it).
    var customerId = root.dataset.customerId || '';
    var guestId = '';
    if (!customerId) {
      try {
        guestId = localStorage.getItem('asn:guest');
        if (!guestId) {
          guestId = 'guest_' + (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2));
          localStorage.setItem('asn:guest', guestId);
        }
      } catch (e) { guestId = 'guest_' + Date.now(); }
    }
    var uploadedPhotoId = '';
    var uploading = false;   // true while a photo is being uploaded to the partner

    /* ---- Reader / carousel ---- */
    var readerPage = root.querySelector('[data-reader-page]');
    var slideUnder = readerPage ? readerPage.querySelector('[data-slide-under]') : null;
    var slideTop = readerPage ? readerPage.querySelector('[data-slide-top]') : null;
    var pg = root.querySelector('[data-reader-pg]');
    var fillEl = root.querySelector('[data-reader-fill]');
    var prevBtn = root.querySelector('[data-reader-prev]');
    var nextBtn = root.querySelector('[data-reader-next]');
    var thumbsEl = root.querySelector('[data-thumbs]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));

    // The thumbnail strip is the slide list — each tile carries the full-size src
    // the stage swaps in. A one-image product renders no strip, so the slide
    // already on screen is the whole list.
    var slides = thumbs.map(function (t) { return t.dataset.src; });
    if (!slides.length && slideTop) {
      var only = slideTop.querySelector('img');
      if (only) slides = [only.src];
    }
    var index = 0;
    var currentFilter = '';
    var underTimer = null;

    var artCardsWrap = root.querySelector('[data-art-cards]');
    var artSection = root.querySelector('[data-art]');

    // No styles to offer (story has none, or the catalog read failed) → drop the
    // whole block rather than invent a list. updateState() already treats "no
    // cards" as "nothing to pick", so the CTA stays reachable.
    function hideArtSection() {
      if (artCardsWrap) artCardsWrap.innerHTML = '';
      if (artSection) artSection.hidden = true;
    }

    // The reader and its thumbnails are Liquid-rendered from the product's own
    // images, so they are on screen at first paint — nothing to wait for and no
    // skeleton. Only the art-style cards still depend on the catalog call.
    function stopArtSkeleton() {
      if (artCardsWrap) artCardsWrap.classList.remove('is-loading');
    }
    // Per-style CSS filter (mirrors the prototype's WB_STYLE_FILTERS).
    var STYLE_FILTERS = {
      watercolor: 'saturate(0.7) brightness(1.08)',
      animated: 'saturate(1.4) brightness(1.05)',
      'soft-dream': 'saturate(0.5) brightness(1.12)',
      storybook: 'saturate(0.9) sepia(0.2)',
      pencil: 'saturate(0.15) brightness(1.1) contrast(0.9)',
      pastel: 'saturate(0.75) brightness(1.1)'
    };
    var CHECK_SVG = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="4 12 10 18 20 6"></polyline></svg>';

    // Build the real art-style cards from the API's styles, each swatch = the cover
    // tinted by that style's filter. Then wire instant re-filtering on click.
    function buildArtCards(styles, cover) {
      if (!artCardsWrap) return;
      if (!styles || !styles.length) { hideArtSection(); return; }
      if (artSection) artSection.hidden = false;
      // Default to the merchant-bound style (product metafield) when it's one of
      // the offered styles; otherwise fall back to the first card. The shopper can
      // still pick any card — that choice is what drives the generation.
      var defaultIdx = 0;
      if (boundArtStyle) {
        for (var di = 0; di < styles.length; di++) {
          if (styles[di].id === boundArtStyle) { defaultIdx = di; break; }
        }
      }
      artCardsWrap.innerHTML = styles.map(function (s, i) {
        var f = STYLE_FILTERS[s.id] || 'none';
        var img = cover ? '<img class="wb-art-cover" src="' + cover + '" alt="" aria-hidden="true" loading="lazy" style="filter:' + f + ';">' : '';
        return '<button type="button" class="wb-art-card' + (i === defaultIdx ? ' on' : '') + '" data-art-card data-filter="' + f + '" data-style="' + s.id + '">'
          + '<span class="wb-art-prev">' + img + '</span>'
          + '<span class="wb-art-name">' + (s.label || s.id) + '</span>'
          + '<span class="wb-art-check">' + CHECK_SVG + '</span></button>';
      }).join('');
      artCardsWrap.classList.remove('is-loading');
      bindArtCards();
      var selected = artCardsWrap.querySelector('[data-art-card].on') || artCardsWrap.querySelector('[data-art-card]');
      if (selected) applyFilter(selected.dataset.filter);   // set the initial filter
    }

    // Selecting a style just re-filters the images — instant, no skeleton.
    function bindArtCards() {
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-art-card]'));
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (c) { c.classList.remove('on'); });
          card.classList.add('on');
          applyFilter(card.dataset.filter);
          updateState();
        });
      });
    }
    // Keep the active thumbnail centred in the strip as the reader pages.
    function centreThumb() {
      var el = thumbs[index];
      if (!el || !thumbsEl) return;
      thumbsEl.scrollTo({ left: el.offsetLeft - (thumbsEl.clientWidth - el.clientWidth) / 2, behavior: 'smooth' });
    }

    function syncChrome() {
      if (pg) pg.textContent = index + 1;
      if (fillEl) fillEl.style.width = ((index + 1) / slides.length) * 100 + '%';
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;
      thumbs.forEach(function (t, i) { t.classList.toggle('on', i === index); });
      centreThumb();
    }

    // The slide being left is parked on the lower layer while the new one slides in
    // from the direction of travel, so paging never flashes the empty frame. The
    // stage cannot be innerHTML-swapped as a whole any more: both layers persist,
    // and the animation is restarted by re-setting the class after a forced reflow
    // (what React got from re-keying the element).
    function goTo(target) {
      if (!slideTop) return;
      if (target < 0 || target > slides.length - 1 || target === index) return;
      var dir = target > index ? 'next' : 'prev';
      if (slideUnder) {
        slideUnder.innerHTML = slideTop.innerHTML;
        slideUnder.hidden = false;
      }
      var thumbImg = thumbs[target] ? thumbs[target].querySelector('img') : null;
      var img = document.createElement('img');
      img.className = 'wb-reader-img';
      img.src = slides[target];
      img.alt = thumbImg ? thumbImg.alt : '';
      img.setAttribute('data-page-img', '');
      if (currentFilter) img.style.filter = currentFilter;
      slideTop.innerHTML = '';
      slideTop.appendChild(img);
      slideTop.className = 'slide';
      void slideTop.offsetWidth;          // restart the animation
      slideTop.className = 'slide ' + dir;
      index = target;
      syncChrome();
      // Once the incoming slide has landed it covers the frame, so the parked one
      // is dropped. It has to go: under "Fit the whole image" the slide is
      // letterboxed and a leftover underneath would show through the bars. A timer
      // rather than `animationend`, which never fires for a slide the browser
      // chose not to animate; paging again just restarts it.
      if (slideUnder) {
        if (underTimer) clearTimeout(underTimer);
        underTimer = setTimeout(function () {
          slideUnder.hidden = true;
          slideUnder.innerHTML = '';
        }, 520);
      }
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
    // The first slide is Liquid-rendered, so nothing has run goTo() yet: settle the
    // counter, the progress fill and the arrow states for slide 1.
    if (slides.length) syncChrome();

    // Swipe to page on touch screens. `touch-action: pan-y` on the frame keeps the
    // vertical scroll of the page itself.
    var touchX = null;
    if (readerPage) {
      readerPage.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      readerPage.addEventListener('touchend', function (e) {
        if (touchX == null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
      });
    }

    /* ---- Illustration style: apply filter 1:1 + call /apps/preview ---- */
    // Every slide carries the style's filter, the cover included — the thumbnails
    // and the stage are one set of images now. goTo() re-applies it to the image it
    // builds, so picking a style and then paging keeps the look.
    function applyFilter(filter) {
      currentFilter = filter || '';
      root.querySelectorAll('[data-page-img]').forEach(function (img) { img.style.filter = currentFilter; });
    }

    // The artwork is the product's own (Liquid). The only thing the catalog is
    // still read for here is the story's art_styles — the ids the partner accepts
    // for this story, which cannot be guessed locally.
    function loadArtStyles() {
      if (!apiBase || !mockStoryId) { hideArtSection(); return; }
      var coverSrc = slides.length ? slides[0] : '';
      fetch(proxyBase + '/upsell?queryType=ai-stories-next-catalog&story_id=' + encodeURIComponent(mockStoryId), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (res) {
          var d = (res && res.data) || {};
          buildArtCards(d.availableStyles || [], coverSrc);   // the story's own styles — no local list
          stopArtSkeleton();
        })
        .catch(function () {
          // Styles have no local fallback: guessing an id the story does not offer
          // is a 422 at generation time. Hide the block instead.
          hideArtSection();
          stopArtSkeleton();
        });
    }

    // Photo guidelines come from the catalog metadata (do/dont lists). The
    // hardcoded lists rendered by Liquid are the fallback; this overwrites them
    // when the API returns guidelines. Icons match the Do (check) / Don't (x)
    // columns so the swapped-in items look identical.
    var DO_ICON = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 12 10 18 20 6"></polyline></svg>';
    var DONT_ICON = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>';
    function fillGuideColumn(col, items, icon) {
      if (!col || !Array.isArray(items) || !items.length) return;
      // Keep the column header; replace only the .wb-guide-item rows.
      col.querySelectorAll('.wb-guide-item').forEach(function (el) { el.remove(); });
      items.forEach(function (line) {
        var text = String(line == null ? '' : line).trim();
        if (!text) return;
        var item = document.createElement('div');
        item.className = 'wb-guide-item';
        var span = document.createElement('span');
        span.textContent = text;
        item.innerHTML = icon;
        item.appendChild(span);
        col.appendChild(item);
      });
    }
    function loadGuidelines() {
      if (!apiBase || !mockStoryId) return;
      var doCol = root.querySelector('[data-guide-do]');
      var dontCol = root.querySelector('[data-guide-dont]');
      if (!doCol && !dontCol) return;   // guidelines section hidden by the merchant
      fetch(proxyBase + '/upsell?queryType=ai-stories-next-metadata', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (res) {
          var g = res && res.data && res.data.photoGuidelines;
          if (!g) return;   // no API guidelines → keep the hardcoded fallback
          fillGuideColumn(doCol, g.do, DO_ICON);
          fillGuideColumn(dontCol, g.dont, DONT_ICON);
        })
        .catch(function () { /* keep the hardcoded fallback */ });
    }

    // The artwork is already on screen (product images). The API is read only for
    // the story's art styles and the photo guidelines; without it there is nothing
    // to offer, so the style block goes away rather than showing invented ids.
    if (apiBase && mockStoryId) {
      loadArtStyles();
      loadGuidelines();
    } else {
      hideArtSection();
    }

    /* ---- Book language chips ---- */
    var langChips = Array.prototype.slice.call(root.querySelectorAll('[data-lang-chip]'));
    langChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        langChips.forEach(function (c) { c.classList.remove('on'); });
        chip.classList.add('on');
      });
    });

    /* ---- Description: clamp to 3 lines, reveal See more/less only when it overflows.
       The intro is duplicated (desktop card + mobile above-reader); only one copy is
       visible at a time, so measure each when it's on screen and re-measure on resize. ---- */
    var descMore = root.dataset.descMore || 'See more';
    var descLess = root.dataset.descLess || 'See less';
    function measureDesc() {
      root.querySelectorAll('[data-desc-wrap]').forEach(function (wrap) {
        if (wrap.dataset.measured) return;
        var desc = wrap.querySelector('[data-desc]');
        var btn = wrap.querySelector('[data-desc-toggle]');
        if (!desc || !btn) return;
        if (desc.offsetParent === null) return; // hidden copy — measure it once shown
        wrap.dataset.measured = '1';
        desc.classList.add('is-clamped');
        if (desc.scrollHeight - desc.clientHeight > 2) {
          btn.hidden = false;
          btn.textContent = descMore;
          btn.addEventListener('click', function () {
            var collapsed = desc.classList.toggle('is-clamped');
            btn.textContent = collapsed ? descMore : descLess;
          });
        } else {
          desc.classList.remove('is-clamped'); // fits in 3 lines — no toggle needed
        }
      });
    }
    measureDesc();
    window.addEventListener('resize', measureDesc, { passive: true });

    /* ---- Guidelines expand/collapse ---- */
    var guide = root.querySelector('[data-guide]');
    var guideToggle = root.querySelector('[data-guide-toggle]');
    if (guide && guideToggle) {
      guideToggle.addEventListener('click', function () {
        var open = guide.classList.toggle('open');
        guideToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* ---- Personalize: photo + name + CTA ---- */
    // Faceswap paints exactly one child photo per story, so we take a single photo.
    var MAX_PHOTOS = 1;
    var photoInput = root.querySelector('[data-photo-input]');
    var upload = root.querySelector('[data-upload]');
    var photosHero = root.querySelector('[data-photos-hero]');
    var addMore = root.querySelector('[data-addmore]');
    var nameInput = root.querySelector('[data-name-input]');
    var chipPhoto = root.querySelector('[data-chip-photo]');
    var chipName = root.querySelector('[data-chip-name]');
    var cta = root.querySelector('[data-cta]');
    var ctaNote = root.querySelector('[data-cta-note]');
    var artLive = root.querySelector('[data-art-live]');
    var artHint = root.querySelector('[data-art-hint]');
    var photos = [];   // object URLs of uploaded photos

    function checkMark() { return '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 12 10 18 20 6"></polyline></svg> '; }
    var removeIcon = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>';

    function updateState() {
      // A photo only "counts" once it has finished uploading to the partner
      // (uploadedPhotoId set) — a local blob preview alone must NOT enable the CTA.
      var hasPhoto = photos.length > 0 && !!uploadedPhotoId;
      var hasName = nameInput && nameInput.value.trim().length > 0;
      // A style counts as chosen when one card is selected — or when the product
      // has no style cards at all (nothing to pick, so it can't block the CTA).
      var styleCount = root.querySelectorAll('[data-art-card]').length;
      var hasStyle = styleCount === 0 || !!root.querySelector('[data-art-card].on');
      var ready = hasPhoto && hasName && hasStyle;

      if (chipPhoto) {
        chipPhoto.classList.toggle('ok', hasPhoto);
        chipPhoto.innerHTML = hasPhoto ? (checkMark() + 'Photo') : '○ Photo';
      }
      if (chipName) {
        chipName.classList.toggle('ok', hasName);
        chipName.innerHTML = hasName ? (checkMark() + 'Name') : '○ Name';
      }
      if (cta) {
        cta.disabled = !ready;
        cta.style.opacity = ready ? '' : '.5';
        cta.style.cursor = ready ? '' : 'not-allowed';
      }
      if (ctaNote) {
        var note = uploading ? 'Uploading your photo…'
          : !hasPhoto ? 'Upload a photo to continue'
          : !hasName ? "Fill in your child's name"
          : !hasStyle ? 'Select an illustration style' : '';
        ctaNote.textContent = note;
        ctaNote.style.display = ready ? 'none' : '';
      }
      // Art-style head: swap the "Upload a photo" hint for a live badge.
      if (artLive) artLive.hidden = !hasPhoto;
      if (artHint) artHint.hidden = hasPhoto;
    }

    function renderPhotos() {
      var hasPhoto = photos.length > 0;
      if (upload) upload.hidden = hasPhoto;
      if (photosHero) {
        photosHero.hidden = !hasPhoto;
        photosHero.innerHTML = photos.map(function (src, i) {
          // While uploading, show a spinner + dim the image and hide the remove
          // button (the photo isn't usable until the partner returns a photo_id).
          var overlay = uploading
            ? '<span class="wb-photo-spinner" aria-label="Uploading photo"></span>'
            : '<button type="button" class="wb-premove" data-premove="' + i + '" aria-label="Remove photo">' + removeIcon + '</button>';
          return '<figure class="wb-photo-hero' + (uploading ? ' is-uploading' : '') + '"><div class="wb-photo-hero-img">'
            + '<img src="' + src + '" alt="Your uploaded photo">'
            + overlay
            + '</div></figure>';
        }).join('');
        photosHero.querySelectorAll('[data-premove]').forEach(function (b) {
          b.addEventListener('click', function () { removePhoto(parseInt(b.dataset.premove, 10)); });
        });
      }
      if (addMore) addMore.hidden = !hasPhoto || photos.length >= MAX_PHOTOS;
      updateState();
    }

    var photoMsg = root.querySelector('[data-photo-msg]');
    function setPhotoMsg(text, kind) {
      if (!photoMsg) return;
      if (!text) { photoMsg.hidden = true; photoMsg.textContent = ''; photoMsg.className = 'wb-photo-msg'; return; }
      photoMsg.hidden = false;
      photoMsg.textContent = text;
      photoMsg.className = 'wb-photo-msg is-' + (kind || 'error');
    }
    // Drop the tile whose blob URL matches (the one whose upload failed/was rejected).
    function dropPhotoByUrl(url) {
      var i = photos.indexOf(url);
      if (i !== -1) removePhoto(i);
    }

    function handleFile(file) {
      if (!file || photos.length >= MAX_PHOTOS) return;
      setPhotoMsg('');
      var blobUrl = URL.createObjectURL(file);
      photos.push(blobUrl);
      renderPhotos();
      // Upload the photo to the partner (via App Proxy) to get a photo_id the
      // Generating page will pass to the generate call. Only a real story product
      // (has a story_id) uploads. The guest id is sent only for anonymous shoppers;
      // logged-in customers are identified by the proxy's logged_in_customer_id.
      if (!uploadedPhotoId && proxyBase && mockStoryId) {
        uploading = true;
        renderPhotos();   // show the spinner + keep the CTA disabled ("Uploading…")
        var photoUrl = proxyBase + '/upsell?queryType=ai-stories-next-photo';
        if (guestId) photoUrl += '&guest_id=' + encodeURIComponent(guestId);
        fetch(photoUrl, {
          method: 'POST',
          headers: { 'Content-Type': file.type || 'image/jpeg' },
          body: file
        })
          .then(function (r) { return r.ok ? r.json() : r.json().catch(function () { return {}; }).then(function (b) { return Promise.reject(b); }); })
          .then(function (res) {
            uploading = false;
            // The shopper removed this photo while it was uploading → ignore the result.
            if (photos.indexOf(blobUrl) === -1) { renderPhotos(); return; }
            var d = (res && res.data) || {};
            if (d.status === 'rejected') {
              // Partner rejected the photo → remove the fake-success preview and explain.
              dropPhotoByUrl(blobUrl);
              setPhotoMsg(d.reason || d.hint || 'This photo can’t be used — please try another.', 'error');
              return;
            }
            uploadedPhotoId = d.photo_id || '';
            if (!uploadedPhotoId) {
              dropPhotoByUrl(blobUrl);
              setPhotoMsg('Upload failed — please try again.', 'error');
              return;
            }
            if (d.status === 'warning') {
              setPhotoMsg(d.reason || d.hint || 'This photo may not give the best result.', 'warning');
            } else {
              setPhotoMsg('');
            }
            renderPhotos();   // swap spinner → remove button, enable the CTA
          })
          .catch(function (b) {
            uploading = false;
            // Network/HTTP error → remove the preview (don’t leave a fake success) and explain.
            if (photos.indexOf(blobUrl) !== -1) dropPhotoByUrl(blobUrl);
            var msg = (b && (b.message || (b.error && b.error.message))) || 'Upload failed — please check your connection and try again.';
            setPhotoMsg(msg, 'error');
          });
      }
    }
    function removePhoto(i) {
      if (i < 0 || i >= photos.length) return;
      try { URL.revokeObjectURL(photos[i]); } catch (e) {}
      photos.splice(i, 1);
      // Clear the partner photo id so picking a different photo re-uploads it
      // (otherwise the guard in handleFile would keep the removed photo's id).
      uploadedPhotoId = '';
      uploading = false;
      renderPhotos();
    }

    if (upload && photoInput) {
      upload.addEventListener('click', function () { photoInput.click(); });
      upload.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); photoInput.click(); } });
      upload.addEventListener('dragover', function (e) { e.preventDefault(); upload.classList.add('drag'); });
      upload.addEventListener('dragleave', function () { upload.classList.remove('drag'); });
      upload.addEventListener('drop', function (e) { e.preventDefault(); upload.classList.remove('drag'); if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]); });
      photoInput.addEventListener('change', function () { if (photoInput.files[0]) handleFile(photoInput.files[0]); photoInput.value = ''; });
    }
    if (addMore) addMore.addEventListener('click', function () { photoInput.click(); });
    if (nameInput) nameInput.addEventListener('input', updateState);

    if (cta) {
      cta.addEventListener('click', function () {
        if (cta.disabled) return;
        // Route through the Generating page (runs the /generate SSE, then hands
        // off to Preview). Falls back to Preview directly if no generating page
        // is configured.
        var url = generatingUrl || '/pages/generating' || previewUrl;
        var sep = url.indexOf('?') >= 0 ? '&' : '?';
        var q = 'product=' + encodeURIComponent(handle);
        var style = root.querySelector('[data-art-card].on');
        if (style && style.dataset.style) q += '&style=' + encodeURIComponent(style.dataset.style);
        if (nameInput && nameInput.value.trim()) q += '&name=' + encodeURIComponent(nameInput.value.trim());
        // Forward the story id + partner photo id to the Generating page. The
        // guest id is not on the URL — the Generating page reads it from
        // localStorage ('asn:guest'), the same store it was created in.
        if (mockStoryId) q += '&story=' + encodeURIComponent(mockStoryId);
        if (uploadedPhotoId) q += '&photoId=' + encodeURIComponent(uploadedPhotoId);
        if (boundTeaser) q += '&teaser=' + encodeURIComponent(boundTeaser);
        // The backend resolves teaser_pages/story_id from the binding by product,
        // so forward the product gid (handle is already on ?product=).
        var productGid = root.dataset.productGid || '';
        if (productGid) q += '&product_gid=' + encodeURIComponent(productGid);
        window.location.assign(url + sep + q);
      });
    }

    /* ---- Mobile pinned FAB: jump to the steps, then flip to "Up top" ---- */
    var fab = root.querySelector('[data-pin-fab]');
    var fabLabel = root.querySelector('[data-pin-label]');
    var fabIcon = root.querySelector('[data-pin-icon]');
    var stepsTarget = root.querySelector('[data-story-personalise]');
    if (fab && stepsTarget) {
      var sparkIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v6m0 6v6m-9-9h6m6 0h6"></path></svg>';
      var upIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline></svg>';
      var atForm = false;
      var syncFab = function () {
        atForm = stepsTarget.getBoundingClientRect().top <= window.innerHeight * 0.33;
        fab.classList.toggle('up', atForm);
        if (fabLabel) fabLabel.textContent = atForm ? 'Up top' : 'Personalise';
        if (fabIcon) fabIcon.innerHTML = atForm ? upIcon : sparkIcon;
      };
      fab.addEventListener('click', function () {
        if (atForm) window.scrollTo({ top: 0, behavior: 'smooth' });
        else stepsTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      window.addEventListener('scroll', syncFab, { passive: true });
      syncFab();
    }

    renderPhotos();
  }

  function initAllStoryProducts() {
    document.querySelectorAll('[data-story-product]').forEach(initStoryProduct);
  }
  if (document.readyState !== 'loading') initAllStoryProducts();
  else document.addEventListener('DOMContentLoaded', initAllStoryProducts);
  document.addEventListener('shopify:section:load', initAllStoryProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-related"] && !Shopify.designMode) return;
  try {
    
  function initStoryRelated(root) {
    if (!root || root.__relInit) return;
    root.__relInit = true;
    var url = root.dataset.relatedUrl;
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-related-root]');
        if (!fresh) return;
        // Whatever came back is the answer, including an empty one: the response
        // already falls back to a collection when the API had no picks, so an
        // empty body means there is genuinely no rail for this product. Either
        // way the skeleton goes — it is a placeholder, never a fallback.
        root.innerHTML = fresh.innerHTML;
      })
      // A failed fetch leaves no rail rather than a rail of the wrong products.
      .catch(function () { root.innerHTML = ''; });
  }
  function initAllStoryRelated() {
    document.querySelectorAll('[data-related-root]').forEach(initStoryRelated);
  }
  if (document.readyState !== 'loading') initAllStoryRelated();
  else document.addEventListener('DOMContentLoaded', initAllStoryRelated);
  document.addEventListener('shopify:section:load', initAllStoryRelated);

  } catch(e) { console.error(e); }
})();
})();
